module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "introduction",
      "id": "intro"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p1"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rintro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Proverbs, Job and Ecclesiastes are usually referred to as the ‘wisdom’ books of the Hebrew Bible. They differ considerably in literary genres, but together account for most of the occurrences of the various forms of the Hebrew root "), _c('i', [_vm._v("ḥkm,")]), _vm._v(" meaning ‘wisdom’, ‘wise’, ‘to be wise’ in the OT. Other words are characteristic of these books but not common outside of them. They also share a common approach to reality, which is ‘humanistic’ and ‘experiential’. Many of the things normally seen as distinctively Israelite are absent from them. The great moments of Israel’s history get no mention, nor do the covenants with Abraham, Moses and David. The Temple, its sacrificial system and calendar of feasts are barely mentioned. There is no mention of priest or prophet alongside ‘the wise’.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro01"
    }
  }, [_vm._v("What Is Wisdom?")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One way of answering this question is to consider the people who are called ‘wise’ in the OT. Regarding the construction of the Tabernacle God says to Moses: ‘I have given "), _c('i', [_vm._v("wisdom")]), _vm._v(" to all the "), _c('i', [_vm._v("wise of heart,")]), _vm._v(" so that they may make all that I have commanded you’ (Exod. 31:6). These are people skilled in artistic design, metalwork, woodwork, working with precious stones, spinning, weaving and embroidery. Sailors able to navigate across the sea are called ‘wise’ (Ezek. 27:8). Solomon was given ‘wisdom’ in response to a prayer for the ability to rule well (1 Kgs. 3:9, 12). ‘Wisdom’ is also used of cunning (2 Sam. 13:3) and political pragmatism (1 Kgs. 2:6). These examples suggest that, in its widest sense, ‘wisdom’ in the OT is "), _c('i', [_vm._v("the ability to cope with life.")]), _vm._v(" Consideration of the kind of topics covered in Proverbs supports this: marriage and family life, friends and neighbours, care for the poor and needy, agriculture, commerce, behaviour in the law courts and in the royal court.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p2"
    }
  }), _vm._v("Within the wisdom literature the meaning of ‘wisdom’ becomes narrower. Whybray"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn1",
      "id": "fn1r"
    }
  }, [_vm._v("1")]), _vm._v(" says, ‘in Proverbs "), _c('i', [_vm._v("ḥokmâ")]), _vm._v(" is always "), _c('i', [_vm._v("life")]), _vm._v("-skill: the ability of the individual to conduct his life in the best possible way and to the best possible effect’. In the wisdom literature ‘wisdom’ is often coupled with words meaning ‘understanding’ or ‘knowledge’, giving it a more ‘intellectual’ slant. Wisdom is seen as ‘an intellectual quality which provides the key to happiness and success, to “life” in its widest sense’."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn2",
      "id": "fn2r"
    }
  }, [_vm._v("2")]), _vm._v(" But ‘wisdom’ in the OT is not to be equated with ‘intelligence’. It is always about the skill of coping with life on a practical level. Also, it is something that can be acquired, as the ‘prologue’ to the Book of Proverbs asserts (Prov. 1:2-6). What is more, true ‘wisdom’ is rooted in commitment to Yahweh, ‘the fear of the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v("’ (Prov. 1:7; 9:10; see the comment on 1:7).")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro02"
    }
  }, [_vm._v("What Is a Proverb?")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The Hebrew word that is used (in a plural form) in Prov. 1:1, which is translated into English as ‘proverb’ is "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb5.jpg",
      "width": "22"
    }
  }), _vm._v(" "), _c('i', [_vm._v("(māšāl).")]), _vm._v(" The exact sense of the word is unclear. It could be related to a verb meaning ‘to rule’ and so mean a word that gives mastery, or a powerful word. Alternatively it could come from a verb meaning ‘to be like’, and so mean a comparison."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn3",
      "id": "fn3r"
    }
  }, [_vm._v("3")]), _vm._v(" In fact only a minority of the sayings in Proverbs are direct comparisons, whether explicit (similes) or implicit (metaphors). In addition, the term "), _c('i', [_vm._v("māšāl")]), _vm._v(" is used fairly often in the Hebrew Bible and is applied to sayings, which have a wide variety of literary forms, for example: a satirical poem (Isa. 14:4), a psalm (Ps. 78:2), an allegory (Ezek. 17:2). The word, therefore, does not seem to refer to a specific literary form. Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn4",
      "id": "fn4r"
    }
  }, [_vm._v("4")]), _vm._v(" argues that the main characteristic of a "), _c('i', [_vm._v("māšāl")]), _vm._v(" is that it ‘has currency among people.’ The saying, ‘Is Saul too among the prophets?’ became a "), _c('i', [_vm._v("māšāl")]), _vm._v(" (1 Sam. 10:12) by repetition so that it gained currency among people. This, he argues, is the meaning of the word "), _c('i', [_vm._v("māšāl")]), _vm._v(" in Prov. 1:1, 6; 10:1; 25:1; 26:7, 9.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro03"
    }
  }, [_vm._v("The Structure of the Book of Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("There are seven headings which clearly divide the book as we have it into sections.")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "ulf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p3"
    }
  }), _vm._v("1:1 The proverbs of Solomon son of David, king of Israel.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("10:1 The proverbs of Solomon")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("22:17 Incline your ear, and hear the words of the wise.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("24:23 These also are sayings of the wise.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("25:1 These also are proverbs of Solomon which the men of Hezekiah, king of Judah, copied.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:1 The words of Agur son of Jakeh.")]), _vm._v(" "), _c('li', {
    staticClass: "ull"
  }, [_vm._v("31:1 The words of King Lemuel. An oracle that his mother taught him.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The LXX of 22:17 reads, ‘To the words of the wise, lend your ear and hear my word.’ In the light of this most commentators and translations now emend the Hebrew of this verse to read, ‘The words of the wise. Incline your ear and hear my words, and apply your mind to my teaching’, so making the ‘title’ clearer.")]), _vm._v(" "), _c('p', [_vm._v("There are differences in the form and style of the material which suggests the existence of distinct sections, and some of these coincide with the sections indicated by the headings. Proverbs 10:1–22:16 and 25:1–29:27 consist of ‘sentence proverbs’. Each sentence is usually a couplet displaying parallelism between its two halves. Although there are groups of proverbs based on common themes or words, these do not form a reasoned ‘discourse’. In 22:17–24:22 the basic unit is a four-part sentence which usually has the form of a command followed by a reason, or motive, for obeying it. Proverbs 24:23-34 also consists mainly of four-part sentences. The material in chs. 1–9 is different again in its form. It contains several connected discourses, poems and speeches. Proverbs 30:15-33 consists, in the main, of a collection of ‘number proverbs’. The concluding poem in 31:10-31 stands out as a distinct section, both because of its subject and because in form it is an alphabetic acrostic. Each of the twenty-two verses begins with a letter of the Hebrew alphabet, following their normal sequence.")]), _vm._v(" "), _c('p', [_vm._v("One area of debate concerns where ‘The words of Agur’ end. The most obvious break occurs at 30:15, with first of the ‘number proverbs’. It is notable that when the LXX deviates in the order of material after 24:22 it treats 30:1-14 as a distinct section. However, whether all of this is intended to be the words of Agur is widely disputed. There is a list of undesirable persons in 30:11-14, with each item beginning, ‘There are those …’ . Verse 10 might precede this because of the catchword ‘curse’. There is no obvious link between these verses and what precedes them. The prayer in 30:7-9 is seen by some as a fitting climax to the words of Agur. Others suggest that it is a kind of ‘number proverb’, which marks the beginning of a collection in which this form of proverb dominates.")]), _vm._v(" "), _c('p', [_vm._v("There is general agreement that 1:1-7 forms a preface, not just to chs. 1–9, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p4"
    }
  }), _vm._v("but to the whole book. After the heading (v. 1), the purpose of the book is set out in a series of assertions about the benefits that will accrue from paying heed to its contents. Finally, v. 7 sums up the teaching of the whole book.")]), _vm._v(" "), _c('p', [_vm._v("With regard to the rest of chs. 1–9 there is general, though not unanimous, agreement that there are ten sections, each of which begins in the same way."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn5",
      "id": "fn5r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "blf"
  }, [_vm._v("• They are all addressed (in Hebrew) to ‘my son’ (‘sons’ in 4:1) as the first or second word.")]), _vm._v(" "), _c('li', {
    staticClass: "bl"
  }, [_vm._v("• The son is commanded to ‘hear’, ‘receive’, ‘not forget’ and so on, the teaching which follows (in 2:1 this is expressed in conditional form, ‘if …’).")]), _vm._v(" "), _c('li', {
    staticClass: "bl"
  }, [_vm._v("• The personal authority of the speaker, the ‘father’, is asserted.")]), _vm._v(" "), _c('li', {
    staticClass: "bll"
  }, [_vm._v("• The great value and utility of the father’s words are asserted or implied.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("While the beginnings of these sections are clear (1:8-9; 2:1-4; 3:1-2; 3:21-22; 4:1-2; 4:10; 4:20-21; 5:1-2; 6:20-21; 7:1-3), there is some uncertainty about the ending of some of them. There is a fair degree of agreement on three ‘interludes’ between some of them.")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "blf"
  }, [_vm._v("• 1:20-33, Wisdom’s warning.")]), _vm._v(" "), _c('li', {
    staticClass: "bl"
  }, [_vm._v("• 3:13-20, a poem in praise of Wisdom.")]), _vm._v(" "), _c('li', {
    staticClass: "bll"
  }, [_vm._v("• 6:1-19, four admonitions and warnings.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("There is no consensus about the reason for the order of the ten sections and the ‘interludes’. There is no obvious development of thought or thematic arrangement.")]), _vm._v(" "), _c('p', [_vm._v("Chapter 8 stands on its own as a speech by Wisdom. The portraits of personified Wisdom (9:1-6) and Folly (9:13-18) form an appropriate climax to this section of the book. There is debate about the nature and function of 9:7-12.")]), _vm._v(" "), _c('p', [_vm._v("These considerations lead to the following overall structure:")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "ulf"
  }, [_vm._v("1:1–9:18 The Proverbs of Solomon — I\n          "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "ul1"
  }, [_vm._v("1:1-7 Preface")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("1:8-19 Lesson 1")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("1:20-33 Wisdom’s warning")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("2:1-22 Lesson 2")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("3:1-12 Lesson 3")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("3:13-20 A poem in praise of Wisdom")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p5"
    }
  }), _vm._v("3:21-35 Lesson 4")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("4:1-9 Lesson 5")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("4:10-19 Lesson 6")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("4:20-27 Lesson 7")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("5:1-23 Lesson 8")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("6:1-19 Four admonitions and warnings")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("6:20-35 Lesson 9")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("7:1-27 Lesson 10")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("8:1-36 A speech by Wisdom")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("9:1-18 Wisdom and Folly")])])]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("10:1–22:16 The Proverbs of Solomon — II")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("22:17–24:22 The Words of the Wise")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("24:23-34 More Words of the Wise")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("25:1–29:27 The Proverbs of Solomon — III")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:1-14 The Words of Agur\n          "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "ul1"
  }, [_vm._v("30:1-3 A profession of ignorance")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("30:4 A riddle")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("30:5-6 An affirmation about God’s word")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("30:7-9 A prayer")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("30:10 An admonition")]), _vm._v(" "), _c('li', {
    staticClass: "ul1"
  }, [_vm._v("30:11-14 A list of undesirable persons")])])]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:15-33 A Collection of (mainly) Number Proverbs")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("31:1-9 The Words of King Lemuel")]), _vm._v(" "), _c('li', {
    staticClass: "ull"
  }, [_vm._v("31:10-31 The Capable Wife (an alphabetic acrostic poem)")])]), _vm._v(" "), _c('p', [_vm._v("Luc"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn6",
      "id": "fn6r"
    }
  }, [_vm._v("6")]), _vm._v(" challenges the consensus that 22:17 and 24:23 are titles. He argues that in the LXX the phrase ‘words of the wise’ may be merely part of the poetic line, and not a title. It should not be used to ‘restore’ a title in the MT. He agrees with the LXX translation of 24:23, ‘These also are words "), _c('i', [_vm._v("for")]), _vm._v(" the wise’, and links this with the five ‘purpose’ statements in 1:2-6, ‘to make the wise wiser’ (v. 5). Removing these two titles leaves five titles. Luc suggests that the final editor of Proverbs in the MT was deliberately copying the five-fold structure of the Pentateuch. He accepts that, whether or not 22:17 and 24:23 are titles, 22:17–24:22 and 24:23-34 are distinct units within the book.")]), _vm._v(" "), _c('p', [_vm._v("The strongest of Luc’s arguments is his point about 22:17. The emendation of this verse has always been a matter of debate. His translation of 24:23 is less convincing. The appeal to 1:5 is somewhat undermined by the lack of correlation of other sections in the book with the other ‘purpose statements’. Finally, the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p6"
    }
  }), _vm._v("appeal to a final editorial shaping that seeks to parallel the Pentateuch is not convincing. The sections into which the five titles Luc recognises divide the book are very unequal in length. Two are explicitly attributed to non-Israelites. More importantly, concern for the Torah is not at all evident in Proverbs. If the final editor had wanted to make a link between Wisdom and Torah it is surprising that this was not done more obviously.")]), _vm._v(" "), _c('p', [_vm._v("On the basis of form, style and content, Skladny"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn7",
      "id": "fn7r"
    }
  }, [_vm._v("7")]), _vm._v(" argued for a division between chs 10–15 and 16:1–22:16. The proverbs in chs 10–15 are mostly antithetic, while those in 16:1–22:16 are mostly synonymous and progressive. Waltke"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn8",
      "id": "fn8r"
    }
  }, [_vm._v("8")]), _vm._v(" points out that the change seems to take place at 15:30, and suggests that 15:30-33 is prologue to what follows. Toy"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn9",
      "id": "fn9r"
    }
  }, [_vm._v("9")]), _vm._v(" pointed out that chs 25–27 consist largely of comparative proverbs, while antithetic and progressive proverbs predominate in chs 28–29. These differences in form do not correlate with changes in theme or topics covered.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro04"
    }
  }, [_vm._v("Authorship and Date")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The study of the structure of Proverbs shows that it is a collection of collections, some of which are attributed to named or unnamed authors other than Solomon. It is likely that Prov. 1:1 is intended to refer to the book as a whole rather than to the collection in Prov. 1–9. To begin with, it is part of what seems to be a prologue to the whole book: 1:1-7. Then, as Kidner"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn10",
      "id": "fn10r"
    }
  }, [_vm._v("10")]), _vm._v(" points out, ‘If chapters 1–9 consisted of proverbs of Solomon we should expect 10:1 to be phrased: “These also are proverbs of Solomon”, on the pattern of 24:23 and 25:1.’ So, in addition to the collections already discussed, Prov. 1–9 is probably another anonymous, non-Solomonic, collection.")]), _vm._v(" "), _c('p', [_vm._v("In addition to this there is evidence that the major collections are made up of smaller collections. Besides the evidence of form, style and content that has already been noted, there is the fact that there are some proverbs that are repeated more or less word-for-word, for example Prov. 10:1/15:20; 14:12/16:25; 16:2/21:2. Snell"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn11",
      "id": "fn11r"
    }
  }, [_vm._v("11")]), _vm._v(" provides an exhaustive list of repeated proverbs of varying degrees of similarity. This is most likely to happen if the bigger collections were made by combining smaller, pre-existing ones. When a work is built up in this "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p7"
    }
  }), _vm._v("way, it does not make sense to speak of its ‘authorship’ in the way in which that term is normally used.")]), _vm._v(" "), _c('p', [_vm._v("A second factor to bear in mind is that proverbs often arise in an oral context and then may eventually be written down and find their way into a written collection. Wisdom teachers were collectors of material. The preface of the Egyptian "), _c('i', [_vm._v("Instruction of Ptahhotep")]), _vm._v(" makes clear that the book includes ‘the advice of the ancestors’ and ‘the utterances of times past’."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn12",
      "id": "fn12r"
    }
  }, [_vm._v("12")]), _vm._v(" Ben Sirach tells his students, ‘Be ready to listen to every godly discourse, and let no wise proverb escape you’ (Sir. 6:35). Proverbs 25:1 tells us that the ‘men of Hezekiah’ acted as collectors of already existing proverbs. This reference also shows that it is problematic to speak of the date of the Book of Proverbs. Its compilation in the form that we have it took centuries. The phrase ‘these also are proverbs of Solomon’ in 25:1 implies that at that time there was an already existing collection of ‘Solomonic’ proverbs.")]), _vm._v(" "), _c('p', [_vm._v("So what is the meaning of the attributions of proverbs to Solomon in Prov. 1:1; 10:1; and 25:1? They are understandable in the light of the tradition of Solomon’s personal wisdom (1 Kgs. 4:29-34). First Kgs. 4:32 says that he ‘spoke 3,000 proverbs’, which may not mean that he composed them. If we think of his activity with regard to proverbs in a wider sense than that of an originator of new sayings then, as Clifford"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn13",
      "id": "fn13r"
    }
  }, [_vm._v("13")]), _vm._v(" says, ‘There is no reason … to doubt that some of the book is “by Solomon”, for as king he would have collected, sponsored, or possibly even written, various kinds of writing, including literature "), _c('i', [_vm._v("(belles letters),")]), _vm._v(" as 1 Kings 4:29-31 recognizes.’ It is, however, hard to think of Solomon, or anyone in the royal court, as the originator of much of the material in Proverbs. Very little of it refers directly to life at court and none of it seems to verbalise the view-point of a monarch. The most prominent social settings reflected in the book are those of the moderately well-off rural farmer and the urban artisan. It seems likely that the attribution of the book and two collections in it to Solomon serves primarily as noting his foundational role in the collecting of proverbs in Israel, though this does not exclude the reshaping of some proverbs as they were written down, and the creation of some new ones.")]), _vm._v(" "), _c('p', [_vm._v("If a ‘Solomonic’ collection began to take shape during his reign (latter part of the tenth century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(") the compilation of the book continued until at least the time of Hezekiah (late eighth century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v("). Attempts to date material in the book by various means have led to little in the way of consensus. It is in the nature of proverbs that they do not contain specific historical references by which they can be dated, though references to the king in some proverbs "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p8"
    }
  }), _vm._v("suggests that these are pre-exilic in origin. After a brief survey of a number of linguistic features Clifford"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn14",
      "id": "fn14r"
    }
  }, [_vm._v("14")]), _vm._v(" concludes that, apart from the fact that the absence of Graecisms suggests a pre-Hellenistic date, ‘In sum, the book cannot be dated with certainty from its language.’ Most scholars think that Prov. 1–9 and 31:10-31 look as if they have been composed as an introduction and conclusion to the book, and so are the latest parts of it. However, views on the dating of Prov. 1–9 differ widely. On the basis of similarities with Egyptian instructions, Kayatz"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn15",
      "id": "fn15r"
    }
  }, [_vm._v("15")]), _vm._v(" argued for a pre-exilic dating. Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn16",
      "id": "fn16r"
    }
  }, [_vm._v("16")]), _vm._v(" thinks that literary form is of little help in dating and considers a Persian or early Hellenistic date likely because, ‘Some parts of Prov. 1–9, especially ch. 8, seem to me to be a response to Greek philosophy, though this is an uncertain basis for dating.’ Even Waltke,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn17",
      "id": "fn17r"
    }
  }, [_vm._v("17")]), _vm._v(" who attributes most of the book to Solomon, accepts that there was a final editing of the book in which Hezekiah’s collection and the non-Solomonic material in chs. 30–31 was added to an existing Solomonic work, and that ‘This final editor, the real author of the book, not of its sayings, probably lived during the Persian period (ca. 540 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.C.")]), _vm._v("–332 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.C.")]), _vm._v(") or in the Hellenistic era.’")]), _vm._v(" "), _c('p', [_vm._v("Overall there is a fairly widely held consensus that the Book of Proverbs is a collection of collections, the compilation of which probably stretched over a period of at least five hundred years.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro05"
    }
  }, [_vm._v("Literary Forms in Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("An appreciation of the different literary forms which occur in Proverbs and their characteristics helps the reader in understanding and interpreting the book. There are two main literary forms, the "), _c('i', [_vm._v("instruction")]), _vm._v(" and the "), _c('i', [_vm._v("sentence proverb")]), _vm._v(" and a number of other less common forms.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro01"
    }
  }, [_c('i', [_vm._v("The Instruction Form")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("McKane"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn18",
      "id": "fn18r"
    }
  }, [_vm._v("18")]), _vm._v(" carried out a detailed study of Egyptian and Mesopotamian texts. On this basis he was able to define the characteristics of the ‘instruction form’ in ancient Near Eastern wisdom literature.")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nlf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p9"
    }
  }), _vm._v("1. The main element is the imperative or command. This may be either positive or negative. It may be expressed by an imperative, a jussive or a virtual (polite) imperative (‘you shall not’).")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("2. There is often a conditional clause. This defines the condition or circumstance in which the imperative applies. It usually precedes the imperative but may follow it.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("3. There is usually a motive clause. Its function is to recommend that action of the imperative(s) and show its reasonableness. The motive clause can be developed in various ways to give an ‘extended motivation’.")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("4. There is sometimes a consequence clause. This normally expresses the outcome of obeying the imperative in terms of a desirable objective. The distinction between motive and consequence is not clear-cut.")])]), _vm._v(" "), _c('p', [_vm._v("The ‘instruction form’ form is to be found in Prov. 1–9; 22:17–24:22; and 31:1-9. A straightforward example of a command followed by motive is provided by Prov. 3:1-2:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Command:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("My child, do not forget my teaching,")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("but let your heart keep my commandments;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Motive:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("for length of days and years of life")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and abundant welfare they will give you.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("A rather complex example is provided by Prov. 1:10-19.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Condition:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("My child, if sinners entice you,")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Command:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("do not consent.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Condition:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("If they say, ‘Come with us, let us lie in wait for blood;")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("let us wantonly ambush the innocent;")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("like Sheol let us swallow them alive and whole,")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("like those who go down to the Pit.")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("We shall find all kinds of costly things;")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("throw your lot among us;")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("we will all have one purse’ —")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Command:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("my child, do not walk in their way,")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("keep your foot from their paths;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Motive:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("for their feet run to evil,")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and they hurry to shed blood.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Consequence:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("For in vain is the net baited while the bird is looking on;")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("yet they lie in wait — to kill themselves!")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and set ambush — for their own lives!")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p10"
    }
  }), _vm._v("Such is the end of all who are greedy for gain;")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("It takes away the life of its possessors.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This example illustrates the difficulty of distinguishing between motive and consequence clauses. It is possible to take vv. 17-19 as an extension of the motive clause. However, these verses express the negative consequences of the actions of the ‘sinners’, so are better seen as a negative version of the consequence clause in that they express the consequence of not heeding the commands.")]), _vm._v(" "), _c('p', [_vm._v("There can be some confusion when people fail to distinguish between the ‘instruction form’ as defined above and a piece of literature that is ‘an instruction book/lecture/unit’. The literary unit begins with an introduction which addresses the reader, often as ‘my son’, with a call to listen to and heed the teaching that follows. The purpose and value of the teaching may be emphasised. This introduction itself has the instruction form and so does all, or most, of the teaching that follows.")]), _vm._v(" "), _c('p', [_vm._v("Each lesson in Prov. 1–9 forms an instruction unit. Fox,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn19",
      "id": "fn19r"
    }
  }, [_vm._v("19")]), _vm._v(" who calls them ‘lectures’, divides each of them into three major parts:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nlf"
  }, [_vm._v("1. "), _c('i', [_vm._v("Exordium.")]), _vm._v(" The introduction to the lesson, which usually contains an "), _c('i', [_vm._v("address")]), _vm._v(" to the son(s), an "), _c('i', [_vm._v("exhortation")]), _vm._v(" and a "), _c('i', [_vm._v("motivation")]), _vm._v(" to support the exhortation.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("2. "), _c('i', [_vm._v("Lesson.")]), _vm._v(" The body of the teaching.")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("3. "), _c('i', [_vm._v("Conclusion.")]), _vm._v(" A summary of the teaching, which may end with a "), _c('i', [_vm._v("capstone,")]), _vm._v(" a memorable saying that reinforces the teaching.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In the commentary we shall refer to these three sections as the ‘introduction’, ‘main body’ and ‘conclusion’ of each lesson.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro02"
    }
  }, [_c('i', [_vm._v("The Sentence Proverb")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("This is the basic unit of Prov. 10:1–22:16 and 25:1–29:27. In most cases the sentence is made up of two ‘lines’ or ‘cola’ (singular: colon) and exhibits the parallelism that is a feature of Hebrew poetry. Three types of parallelism are very common in Proverbs.")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "blf"
  }, [_vm._v("• "), _c('b', [_vm._v("Antithetic parallelism")]), _vm._v(". In this type the second colon expresses a contrast to the first, for example ‘A slack hand causes poverty, but the hand "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p11"
    }
  }), _vm._v("of the diligent makes rich’ (10:4). Most of the proverbs in chs. 10–15 use antithetic parallelism")]), _vm._v(" "), _c('li', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('b', [_vm._v("Synonymous parallelism")]), _vm._v(". In this case the second colon repeats the essential point of the first, but in different words, for example ‘Pride goes before destruction, and a haughty spirit before a fall’ (16:18).")]), _vm._v(" "), _c('li', {
    staticClass: "bll"
  }, [_vm._v("• "), _c('b', [_vm._v("Progressive parallelism")]), _vm._v(". In this type the second colon builds on or extends what has been said in the first, for example ‘A fool takes no pleasure in understanding, but only in expressing personal opinion’ (18:2).")])]), _vm._v(" "), _c('p', [_vm._v("The sentences in Proverbs are usually very terse. The colon often consists of two items juxtaposed without a verb, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("One who loves wrong, one who loves strife:")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("One who makes his gate high, one who seeks destruction. (17:19)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Here four items form two pairs. Another example is,")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Hope deferred, a sick heart:")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("And/but a tree of life, desire fulfilled. (13:12)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The simple juxtaposition of items may mean that it is unclear which is the subject and which the predicate. One has to rely on the content when determining this.")]), _vm._v(" "), _c('p', [_vm._v("There is sometimes an implicit comparison in the juxtaposition, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("A city breached without a wall:")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("A man who does not control his spirit. (25:28)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Quite often a simple "), _c('i', [_vm._v("wāw")]), _vm._v(" (and/but) serves as an implicit comparative particle, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Cold water upon an exhausted soul:")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("And/but (like) good news from a distant land. (25:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In similes the comparison is made explicit by the use of particles such as "), _c('i', [_vm._v("kî")]), _vm._v(" (like) and "), _c('i', [_vm._v("kēn")]), _vm._v(" (so), for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Like a bird wandering from its nest:")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("so is a man wandering from his place. (27:8)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p12"
    }
  }), _vm._v("Like snow in summer and like rain in harvest:")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("so honour is out of place for a fool. (26:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Both implicit comparisons and similes are particularly common in Prov. 25–27.")]), _vm._v(" "), _c('p', [_vm._v("The sentences can be divided into indicatives (which simply make a statement) and imperatives (usually called ‘admonitions’). The admonitions may be either positive (commands) or negative (prohibitions). There are some notable subgroups among the indicative sentences.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro01"
    }
  }, [_c('i', [_vm._v("The ‘Good’ Sayings")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In fact the majority of these are ‘not good’ "), _c('i', [_vm._v("(lō ʾ tôb)")]), _vm._v(" sayings, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("To impose a fine on a righteous man is not good,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("nor to strike the noble for their uprightness. (17:26)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Other examples of this are: 18:5; 19:2; 20:23; 24:23b; 25:27; 28:21. A weaker form of ‘not good’ is ‘not becoming/fitting’ "), _c('i', [_vm._v("(lō ʾ nā ʾwâ),")]), _vm._v(" as in 17:7; 19:10; 26:1. The opposite of ‘not good’ is ‘how good’ "), _c('i', [_vm._v("(mah tôb),")]), _vm._v(" as in 15:23.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro02"
    }
  }, [_c('i', [_vm._v("The ‘Abomination’ Sayings")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Most of these contrast something that is an ‘abomination to the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v("’ with what ‘delights’ him, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("A false balance is an abomination to the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but a just weight is his delight. (11:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Other examples of this contrast are: 11:1, 20; 12:22; 15:8, 26; 16:5; 20:23; 28:9; 29:27. Proverbs 3:32 and 16:5 lack the contrast, and 6:16 lists ‘seven things that are an abomination to the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v("’. The phrase ‘abomination to the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v("’ occurs only in Proverbs and Deuteronomy.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro03"
    }
  }, [_c('i', [_vm._v("The ‘Better’ Sayings")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The simple form of these has the form, ‘A is better than B’, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p13"
    }
  }), _vm._v("Whoever is slow to anger is better than the mighty,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("and he who rules his spirit than he who takes a city. (16:32)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Other examples of this simple form are: 3:14; 8:11, 19; 22:1; 25:7. A more common form has the pattern, ‘A with B is better than C with D’, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Better is a little with righteousness,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("than great revenues with injustice. (16:8)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Other examples of this form are: 12:9; 15:16, 17; 16:19; 17:1; 19:1; 27:5, 10b; 28:6.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro04"
    }
  }, [_c('i', [_vm._v("The ‘Beatitudes’ or ‘Blessings’")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("These normally begin with the predicative adjective ‘blessed/happy’ ("), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb6.jpg",
      "width": "29"
    }
  }), _vm._v("/"), _c('i', [_vm._v("ʾašrê")]), _vm._v("), which points to a state of well-being and contentment, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Whoever despises his neighbour is a sinner,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but blessed is he who is generous to the poor. (14:21)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Other examples of beatitudes (also in the second colon) are: 16:20 and 29:18 (see also 8:32, 34).")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro03"
    }
  }, [_c('i', [_vm._v("Structural Units in the Sentence Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Yoder"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn20",
      "id": "fn20r"
    }
  }, [_vm._v("20")]), _vm._v(" expresses the view of many commentators and readers of Proverbs when she says,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Proverbs 10:1–22:16 consists largely of two-line proverbs, each of which may stand on its own and each of which — at least initially — appears disconnected with the proverbs that precede and follows it … this seemingly haphazard arrangement is disorienting … proverbs follow one after another in no apparent order of priority.")])]), _vm._v(" "), _c('p', [_vm._v("Not all scholars agree that the arrangement of sentence proverbs in Prov. 10–29 is haphazard. Some have argued for the existence of various kinds of compositional units in this section of the book.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro05"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p14"
    }
  }), _c('i', [_vm._v("Proverbial Pairs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Hildebrandt"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn21",
      "id": "fn21r"
    }
  }, [_vm._v("21")]), _vm._v(" argues that this section of the book contains ‘proverbial pairs’ bound together by various rhetorical devices. The most common device is catchword repetition. This is particularly significant when the catchwords are low-frequency words, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("For lack of "), _c('i', [_vm._v("wood")]), _vm._v(" the "), _c('i', [_vm._v("fire")]), _vm._v(" goes out,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("and where there is no whisperer, quarrelling ceases.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("As charcoal is to hot embers and "), _c('i', [_vm._v("wood")]), _vm._v(" to "), _c('i', [_vm._v("fire,")])]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("so is a quarrelsome person for kindling strife. (26:20-21)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Another strong indication of an intentional pair is the existence of multi-catchwords, for example:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Do not withhold discipline from your children;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("if you beat them with a rod, they will not die.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("If you beat them with the rod,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("you will save their lives from Sheol. (23:13-14)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This example shows that bonding by multi-catchwords may also result in bonding by a common theme. Another example of thematic bonding is,")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("The righteousness of the blameless keeps their ways straight,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("but the wicked fall by their own wickedness.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("The righteousness of the upright saves them,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but the treacherous are taken by their schemes. (11:5-6)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Here there is the high-frequency catchword ‘righteousness’ but the bond is strengthened by the common theme that righteousness leads to success and wickedness to disaster.")]), _vm._v(" "), _c('p', [_vm._v("Syntactic bonding is less conclusive than catchword or thematic bonding. The two strongest forms of it are direct dependence and linking particles.")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Do not make friends with a man given to anger,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("nor go with a man of wrath,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("lest you may learn his ways")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("and entangle yourself in a snare. (22:24-25)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p15"
    }
  }), _vm._v("The third-person masculine singular pronominal suffix in ‘his ways’ points back to ‘the man of wrath. There is also the linking word "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb7.jpg",
      "width": "12"
    }
  }), _vm._v(" ("), _c('i', [_vm._v("pen,")]), _vm._v(" ‘lest’).")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro06"
    }
  }, [_c('i', [_vm._v("Proverb Strings")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Hildebrandt"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn22",
      "id": "fn22r"
    }
  }, [_vm._v("22")]), _vm._v(" subsequently used consideration of various rhetorical devices as the basis for identifying four ‘strings’ of proverbs in Prov. 10. The identification of 10:1-5 and 10:6-11 as separate ‘strings’ is convincing. Both are bounded by "), _c('i', [_vm._v("inclusios.")]), _vm._v(" The proposed ‘strings’ in 10:12-21 and 10:22-30 rely on rather convoluted proposed structures which are much less convincing. They seem like unsuccessful attempts to bring together smaller, independent units.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro07"
    }
  }, [_c('i', [_vm._v("Proverb Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Van Leeuwen"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn23",
      "id": "fn23r"
    }
  }, [_vm._v("23")]), _vm._v(" used structuralist, rhetorical and semantic approaches to study Prov. 25–27. He identified a coherent ‘proverb poem’ in ch. 25 and three other ‘proverb poems’ in ch. 26, but could not find a coherent literary unit in ch. 27, concluding that it is a ‘proverb miscellany’.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro08"
    }
  }, [_c('i', [_vm._v("Proverbial Clusters")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Heim seeks to identify ‘proverbial clusters’ in Prov. 10:1–22:16. He provides"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn24",
      "id": "fn24r"
    }
  }, [_vm._v("24")]), _vm._v(" a valuable survey and critique of scholarly views about the way the sayings are, or are not, organised in Prov. 10:1–22:16. On his part he argues"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn25",
      "id": "fn25r"
    }
  }, [_vm._v("25")]), _vm._v(" that the primary criteria for the delimitation of cluster should not be ‘boundary markers’ but linking devices. ‘The focus should not be on what "), _c('i', [_vm._v("divides")]), _vm._v(" or "), _c('i', [_vm._v("separates")]), _vm._v(" groups from their environment, but on features which "), _c('i', [_vm._v("link")]), _vm._v(" and "), _c('i', [_vm._v("combine")]), _vm._v(" sayings into organic units’. In particular he looks for repetition — such as repetition of consonants, word roots, words, synonyms. The positioning of some linking features makes them boundary markers. Another criterion for distinguishing one cluster from another is the change in linking devices.")]), _vm._v(" "), _c('p', [_vm._v("Waltke"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn26",
      "id": "fn26r"
    }
  }, [_vm._v("26")]), _vm._v(" uses ‘the mostly single-line rearing (or educative) proverbs’ as "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p16"
    }
  }), _vm._v("a guide to identifying the beginning of what he calls ‘units’. He then divides these into ‘subunits’ which more-or-less correspond to what Heim calls ‘clusters’. The criteria he uses"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn27",
      "id": "fn27r"
    }
  }, [_vm._v("27")]), _vm._v(" in linking proverbs together are such things as "), _c('i', [_vm._v("inclusio,")]), _vm._v(" catchwords, structural patterns such as a "), _c('i', [_vm._v("chiasmus")]), _vm._v(" and logical or thematic connections.")]), _vm._v(" "), _c('p', [_vm._v("In this commentary I try to identify ‘proverbial clusters’ and other structures in the sentence literature using the criteria used by Waltke and Heim. I give a higher priority than Heim does to thematic connections, while recognising that this may introduce a higher degree of subjectivity, and I do not try as hard as Waltke to find logical or thematic connections. I do not assume that they must always be there.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro09"
    }
  }, [_c('i', [_vm._v("Comparing Clusters")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("There is not space in the commentary to give a detailed argument for the clusters that are identified. Table 1 on page 17 is a fairly detailed analysis of the clusters that are identified in chs. 10 and 11, and a comparison is made with those identified by Heim"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn28",
      "id": "fn28r"
    }
  }, [_vm._v("28")]), _vm._v(" and Waltke."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn29",
      "id": "fn29r"
    }
  }, [_vm._v("29")]), _vm._v(" From this readers can get a feel for the different approaches and draw their own conclusions about these approaches. The ‘commentary’ on the clusters is based on my own division of the chapters into clusters and gives some justification for it.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:1-5.")]), _vm._v(" Waltke separates out v. 1 as an introductory ‘educative proverb’ but recognises the "), _c('i', [_vm._v("inclusio")]), _vm._v(" made by the construct form "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb8.jpg",
      "width": "14"
    }
  }), _vm._v(" "), _c('i', [_vm._v("bēn")]), _vm._v(" which delimits vv. 1-5. All three recognise that there is a chiastic pattern of positive and negative statements between pairs of verses, so that the second line of one verse corresponds with the first line of the next. Lucas and Walke recognise a theme of wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:6-11.")]), _vm._v(" Lucas and Heim see the repetition of v. 6b in v. 11b and the righteous/wicked contrast in these verses as delimiting this cluster. Lucas also notes that v. 11a may be a development of v. 6a. The mouth of the righteous passes on the blessings they have received. Waltke sees the mention of ‘mouth’ in vv. 6b and 14b as forming an "), _c('i', [_vm._v("inclusio.")]), _vm._v(" He then divides the cluster into two halves, each of four antithetical proverbs (vv. 6-9, 11-14) with v. 10 as what he calls ‘a janus pivot’ which looks both backwards and forwards.")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th",
    attrs: {
      "colspan": "5"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p17"
    }
  }), _c('span', {
    staticClass: "thn"
  }, [_vm._v("Table 1.")]), _vm._v(" Comparing clusters in Proverbs 10 and 11")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tchbottom"
  }, [_c('b', [_vm._v("Waltke")])]), _vm._v(" "), _c('td', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('th', {
    staticClass: "tchbottom"
  }, [_c('b', [_vm._v("Heim")])]), _vm._v(" "), _c('td', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('th', {
    staticClass: "tchbottom"
  }, [_c('b', [_vm._v("Lucas")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("10:1-17")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:1-5")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:1-5")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:2-5")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:6-14")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:6-11")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:6-11")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:12")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:15-16")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:12-18")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:13-17")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:17")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("10:18-32")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:18-21")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:19-22")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:18-21")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("10:22-30")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:22-26")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:22-25")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:22-25")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:26")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:26")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:27-30")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:27-30")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:27-30")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:31-32")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:31-32")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("10:31-32")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("11:1-8")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("11:1-14")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:1-2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:1")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:3-8")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:2-8")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:2-8")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:9")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:9-14")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:9-14")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:10-15")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:16-22")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:15-21")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:15-21")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('b', [_vm._v("11:22-31")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:22")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:22")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:23-27")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:23-26")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:23-27")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:28-31")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:27-31")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("11:28-31")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:12.")]), _vm._v(" Heim argues that the repetition of ‘hatred’ and ‘covers/conceals’ in vv. 12 and 18 marks off vv. 12-18 as a cluster. However, he recognises that vv. 13-17 are linked by catchwords. Lucas argues that v. 12 is more closely linked to v. 11 than to what follows. There is the catchword link of ‘cover/conceals’, and it can be seen as giving a specific example of the meaning of v. 11a. It seems preferable to take it as a stand-alone proverb loosely related to its context rather than force it into a cluster.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:13-17.")]), _vm._v(" Heim and Lucas note the catchword links between vv. 13-15 (wisdom/wise/ruin) and vv. 16-17 (life), plus a conceptual link between vv. 15 and 16 (wealth/wage/gain). Lucas sees no coherent theme in the cluster formed by these links. Waltke recognises the conceptual link between vv. 15 and 16, which "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p18"
    }
  }), _vm._v("he treats as a proverb-pair. In his view v. 17 is a single educative proverb which introduces a new section.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:18-21.")]), _vm._v(" For Lucas and Waltke it is the fact that each of these verses refers to organs of speech that makes this a cluster. There is a coherent theme of how speech is used, with emphasis on its bad use in vv. 18-19 and its good use in vv. 20-21. Heim links v. 18 with v. 12 (see above) and so detaches it from v. 19. He thinks v. 22 fits better with what precedes it than with what follows but gives it a pivotal role, closing one cluster and opening the next.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:22-25.")]), _vm._v(" All three see a theme running through these verses, though expressing it slightly differently: fear/hope (Heim), dread/desire (Lucas), pain/pleasure (Waltke).")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:26.")]), _vm._v(" Waltke links v. 26 with the preceding verses, arguing that it forms a ‘frame’ with v. 22 on the grounds of form (both use synthetic parallelism) and paronomasia ("), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb9.jpg",
      "width": "25"
    }
  }), _vm._v("/"), _c('i', [_vm._v("ʿeṣeb,")]), _vm._v(" ‘sorrow’, in v. 22b and "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb10.jpg",
      "width": "19"
    }
  }), _vm._v("/"), _c('i', [_vm._v("ʿāṣēl,")]), _vm._v(" ‘sluggard’ in v. 26b). This seems rather forced. Lucas and Heim both see this as a proverb which stands out from its context because of its form (synonymous parallelism and use of simile) and content.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:27-30.")]), _vm._v(" All three see this as a cluster with a similar theme to vv. 22-25, which also begins with a Yahweh proverb.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10:31-32.")]), _vm._v(" All three see this as a proverb pair linked by the mention of speech parts in each of the four cola and the righteous/perverse contrast in each verse.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:1.")]), _vm._v(" Lucas and Heim regard this as a stand-alone proverb because of its distinctive content. Waltke argues that it forms a proverb pair with v. 2 because of a common theme of ‘dishonest evaluation’ since pride is an exaggerated opinion of oneself. This is not a very convincing argument.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:2-8.")]), _vm._v(" Lucas and Heim see in these verses a loose cluster linked by references to destruction/death/perishing on the one hand and being saved on the other. Waltke sees a similar, but more positive, theme of ‘security through righteousness’ in vv. 3-8.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:9-14.")]), _vm._v(" Waltke regards v. 9 as a janus proverb standing between two clusters, having links with both v. 8 and v. 10. Lucas recognises that v. 9 shares the catchword ‘delivered’ with v. 8, but thematically the verse goes with what follows, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _vm._v("forming a loose cluster on the theme of the relationship of the individual with the community, especially through the use of words. Heim notes the change in subject to speech in these verses but links them in a single cluster with vv. 2-8, arguing that there is a common theme of ‘deception’, though the justification for this is not clear. Waltke argues that vv. 14-15 form a proverb pair because both ‘juxtapose imprudent action which brings disaster with prudent action that gives security’. However, he does class v. 15 as a janus proverb which has links with what follows.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:15-21.")]), _vm._v(" Lucas and Heim note a change in vocabulary with v. 15. Gone is the use of vocabulary in the semantic field of speech. The prominent theme in these verses is the consequences of certain characters or actions.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:22.")]), _vm._v(" Lucas and Heim see this as a stand-alone proverb. Waltke sees it as forming an "), _c('i', [_vm._v("inclusio")]), _vm._v(" with v. 16a, which also mentions a woman. However, this is a rather weak linkage.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:23-27.")]), _vm._v(" Lucas and Waltke see here a cluster of proverbs about generosity (vv. 24-26) framed by two proverbs about people’s desires, each of which uses the word ‘good’. Heim recognises this frame but nevertheless links v. 27 with what follows on the grounds that it opens a cluster which draws conclusions from the observations made in vv. 23-26.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11:28-31.")]), _vm._v(" Lucas sees this as a collection of miscellaneous proverbs. Heim argues that these verses contain the theme that altruism is in one’s own interest and Waltke sees in them the theme of ‘gain and loss’.")]), _vm._v(" "), _c('p', {
    staticClass: "psec1"
  }, [_vm._v("From this analysis it can be seen that Heim and Waltke tend to see larger units than I do, but then break them down into subunits which correspond quite closely with the clusters which I identify. There is some encouragement in this degree of agreement to think that the smaller clusters are not just subjective creations by the commentator.")]), _vm._v(" "), _c('p', [_vm._v("Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn30",
      "id": "fn30r"
    }
  }, [_vm._v("30")]), _vm._v(" has critiqued Heim’s work. He finds it unconvincing for a number of reasons.")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nlf"
  }, [_vm._v("1. Heim assumes what is to be proven, that clusters do exist, and this leads to a biased approach. This a fair point, but it is equally biased to assume that there are not any clusters. I have tried to approach the issue without the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p20"
    }
  }), _vm._v("expectation that clusters must exist, but with an openness to see whether there are some.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("2. Proverbs 10:1–22:16 covers a limited number of subjects. Given the terseness of the language, the multivalence of words and the referential ambiguity of many proverbs, it is not hard to find what may be purely unintended correspondences between proverbs. Heim himself is aware of this danger"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn31",
      "id": "fn31r"
    }
  }, [_vm._v("31")]), _vm._v(" and seeks to guard against it by looking for ‘linkages’ of sufficient strength to avoid it. This leads to Fox’s next criticism.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("3. Heim’s approach of looking for literary markers rather than relying primarily on thematic connections, as other commentators have often done, may seem ‘objective’. However, the choice of which repetitions and other patterns are important is to some degree subjective, and at times Fox regards Heim’s choices as ‘idiosyncratic’. I agree with Fox that in some cases Heim seems to be straining to find connections rather than accept that a cluster may not exist. However, this applies to only a minority of cases. One must accept that there is indeed a measure of subjectivity in the choice of criteria for linkages and the application of them. In the natural sciences there is recognition of the importance of ‘inter-subjective verification’ as a way of ameliorating this. As commented above, the measure of agreement between Heim, Waltke and myself in identifying clusters, using somewhat different approaches, is encouraging for this reason.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("4. Heim’s approach is too esoteric. It requires a ‘skilled and equipped analyst’ with plenty of time to devote to the task to uncover the patterns which Heim finds. It is unlikely that the compilers of the collections in Proverbs would put such patterns there and expect the readers to find them. In response it can be said that the compilers were themselves scholars and, according to the prologue in Prov. 1:2-7, intended to address a readership ranging from fellow scholars (‘the wise’) to the ‘simple’ reader referred to in the book. They might have put in patterns that only ‘the wise’ would be able to perceive. This would give the book different levels of meaning for readers of different reading competency. There is, however, a danger of being too esoteric in approach and this is why I have put more emphasis than Heim on the more obvious criterion of looking for thematic or logical connections of meaning while recognising that there might also be other, less obvious, patterns marking out clusters.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("5. Although most commentators have recognised the existence of some thematic groups in proverbs above the level of proverb-pairs, few have found "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p21"
    }
  }), _vm._v("the preponderance of clusters that Heim does. In his survey of scholars who have denied the existence of coherent clusters Heim points out the existence of various biases which might lead to scholars not recognising such clusters. In any case the history of biblical studies provides examples of the appearance of new ways of reading texts that bring to light things which previous scholars have not noticed. A relevant example is the rise of ‘redaction criticism’ which has thrown new light on various biblical books, beginning with the NT Synoptic Gospels.")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("6. Heim’s stated goal is to find a way of reading Proverbs that is relevant for a practicing pastor and preacher. Fox finds this ‘of doubtful appropriateness to scholarly analysis’. This does not seem a fair criticism. Whatever Heim’s goal, the value of it to scholars must be judged by the outcome, not the motivation. Most pastors and preachers probably find redaction criticism a more ‘preacher-friendly’ way to read the Gospels than some of the other historical-critical approaches, but that does not make it inappropriate as a means of scholarly analysis of the Gospels.")])]), _vm._v(" "), _c('p', [_vm._v("While rejecting what he calls Heim’s ‘totalising’ approach Fox accepts that there is some clustering of proverbs. He thinks that this is the result of ‘associative thinking’ by the editors of the book. As he explains it,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn32",
      "id": "fn32r"
    }
  }, [_vm._v("32")]), _vm._v(" ‘When one thought gives rise to another or one word evokes a related one, the result is an associative sequence.’ The result is a (small) group of proverbs on the same theme and/or with similar wording. He seems to regard this as a largely unintentional process. This may explain some, probably looser, clusters. However, there is no reason why there should not also be some clusters that are the result of intentional activity by the compilers. It is arguable that good teachers would seek to produce such clusters.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro10"
    }
  }, [_c('i', [_vm._v("Clusters and Hermeneutics")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Where structures exist it is important to consider whether they are more than simply literary constructs. They could be hermeneutically significant. Maybe the sentence proverbs in them should not be interpreted atomistically but in the context of the other sentences that make up the structure. Some scholars reject such an approach. Thus McKane"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn33",
      "id": "fn33r"
    }
  }, [_vm._v("33")]), _vm._v(" asserts that the wisdom sentence is a complete entity and goes on to say,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p22"
    }
  }), _vm._v("I am aware that there are editorial principles of different kinds according to which sentences are grouped. I shall call attention to some of these, while maintaining that they are of secondary character and do not contradict the statement that there is, for the most part, no context for the sentence literature.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Commenting on this statement Schwáb"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn34",
      "id": "fn34r"
    }
  }, [_vm._v("34")]), _vm._v(" asks why the reader should ignore or downplay the ‘secondary’ or editorial activity of the compiler of Proverbs when interpreting it. He goes on to say, ‘After all if someone finds in a book a sentence which was previously used in a different context, he/she would still like to understand that sentence in the book which is in his/her hand.’ Again, one can draw attention to the fruitfulness of redaction criticism in the study of other biblical books.")]), _vm._v(" "), _c('p', [_vm._v("Longman"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn35",
      "id": "fn35r"
    }
  }, [_vm._v("35")]), _vm._v(" argues against such an approach. He suggests that the randomness of the collections in Proverbs is deliberate, reflecting the messiness of life. Proverbs is not intended to be a ‘how-to’ fix-it book. However, he admits that this is ‘pure speculation as to the conscious strategy of the redactors of the book.’ I agree with Heim and Waltke that there is evidence which points to a different conscious strategy being used. Because of his ‘speculation’ Longman thinks that when two or more proverbs do seem to form a group this has come about unintentionally by a kind of magnetic attraction and is not hermeneutically significant. He says, regarding proverb pairs, ‘reading the proverb in context does not change our understanding of either proverb. It doesn’t even enrich our understanding.’ The readers of this commentary must judge whether or not that is the case when considering the interpretations it gives of proverbs within clusters. Finally, Longman says, ‘for a proverb to come alive again, it needs to be spoken orally in the right context.’ However, a speaker cannot decide what that right context for a proverb is without having some idea about its possible meaning(s), and this has to arise from reading it in a collection in Proverbs. It is not unreasonable to at least consider whether the compiler(s) have given some help with this by the context in which they have put a proverb. This commentary will explore that possibility.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro04"
    }
  }, [_c('i', [_vm._v("Rhetorical Devices in Sentence Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In Hebrew the proverb is a form of poetry and shares the main characteristics of Hebrew poetry. These are: parallelism, terseness and use of figurative language."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn36",
      "id": "fn36r"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p23"
    }
  }), _c('b', [_vm._v("Parallelism")]), _vm._v(" is the most obvious feature of Hebrew poetry, especially in translation. The basic poetic unit is a sentence (or "), _c('i', [_vm._v("bicolon;")]), _vm._v(" plural, "), _c('i', [_vm._v("bicola")]), _vm._v(") consisting of two halves (or "), _c('i', [_vm._v("cola")]), _vm._v(") which can be related to one another in various ways and on a number of levels. The level at which parallelism is most easily appreciated in translation is that of "), _c('i', [_vm._v("semantics,")]), _vm._v(" the meaning of the two cola. This has been discussed in the previous section.")]), _vm._v(" "), _c('p', [_vm._v("Parallelism can occur at the level of sentence structure, or "), _c('i', [_vm._v("syntax.")]), _vm._v(" A number of changes can be used to produce parallelism between the cola that make up a sentence:")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "blf"
  }, [_vm._v("• A noun clause may replace a verb clause:")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("The people curse [verb clause] him who holds back grain,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("but a blessing [noun clause] is on the head of him who sells it. (11:26)")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "blf"
  }, [_vm._v("• A statement in one colon may be followed by a question in the next:")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Wrath is cruel, anger is overwhelming,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("but who can stand before jealousy? (27:4)")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "blf"
  }, [_vm._v("• The form of the verb may change. A passive verb may be followed by an active one:")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("The righteous is delivered [passive] from trouble,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("and the wicked walks [active] into it instead. (11:8)")])]), _vm._v(" "), _c('p', [_vm._v("Parallelism can work in a number of ways at the level of words, the "), _c('i', [_vm._v("lexical")]), _vm._v(" level. A major aspect of this is the use of common ‘word pairs’, such as wise/fool, righteous/wicked, poor/rich, father/mother:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("The tongue of the wise commends knowledge,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("but the mouths of fools pour out folly. (15:2)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("A rich man’s wealth is his strong city;")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("the poverty of the poor is their ruin. (10:15)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("These two examples show another form of variation at the lexical level, the use of a singular noun in one colon (wise, rich) and a plural noun in the other (fools, poor). The variation of singular and plural in the Hebrew cannot always be made apparent in English translation:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p24"
    }
  }), _vm._v("The wicked [sing.] flee [pl.] when no one pursues,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but the righteous [pl.] are bold [sing] as a lion. (28:1)")])]), _vm._v(" "), _c('p', [_vm._v("A form of parallelism that cannot be preserved in translation is "), _c('i', [_vm._v("phonological,")]), _vm._v(" or sound, parallelism. This may involve the repetition of syllables, consonants and/or vowel sounds:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("l")]), _c('i', [_vm._v("ō ʾ yeʾ")]), _vm._v(" "), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('i', [_vm._v("hab")]), _vm._v(" "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("l")]), _c('i', [_vm._v("ēṣ hôkēaḥ")]), _vm._v(" "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("l")]), _c('i', [_vm._v("ô")])]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_c('i', [_vm._v("ʾe")]), _c('span', {
    staticClass: "bi"
  }, [_vm._v("l")]), _vm._v(" "), _c('i', [_vm._v("ḥ")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("a")]), _c('i', [_vm._v("kāmîm")]), _vm._v(" "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("l")]), _c('i', [_vm._v("ō ʾ yē")]), _c('span', {
    staticClass: "bi"
  }, [_vm._v("l")]), _c('i', [_vm._v("ēk")]), _vm._v(" (15:12)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("A scoffer does not like to be reproved;")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("he will not go to the wise.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Terseness")]), _vm._v(" is achieved in Hebrew poetry in two main ways. One, which is not usually apparent in translation, is by the omission of various Hebrew particles that are common in prose, such as the definite object marker, the prefix that indicates the definite object, and the relative pronoun. The other way of achieving terseness is ‘gapping’, the omission of words. O’Connor"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn37",
      "id": "fn37r"
    }
  }, [_vm._v("37")]), _vm._v(" claims that ‘gapping’ is a major feature of Hebrew poetry and does not occur in prose. A common form of ‘gapping’ is when the second colon omits the verb used in the first.")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("A gift in secret averts anger,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("and a concealed bribe, strong wrath. (21:14)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("When justice is done, it is a joy to the righteous,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but terror to evildoers. (21:15)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In the second example a whole clause is ‘gapped’.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Figurative language")]), _vm._v(" occurs in prose but it is used much more often, and in greater concentration, in poetry. Hebrew poetry makes use of a wide range of figurative language. Figurative comparisons are particularly common in proverbs. They are a form of ‘terseness’ since they can enable a brief saying to convey a lot of meaning at several levels. The comparisons may be either explicit ("), _c('i', [_vm._v("simile,")]), _vm._v(" using the comparative terms ‘like/as’) or implicit "), _c('i', [_vm._v("(metaphor).")]), _vm._v(" In both cases the things compared are unlike in nature yet have something in common. The distinction between the two forms of comparison is not always kept in English translation. The first example below is a metaphor in Hebrew "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p25"
    }
  }), _vm._v("since it does not have the word ‘like’, whereas the others do, and so are similes. The second example, unusually, spells out the point of comparison.")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("[Like] a gold ring or an ornament of gold")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("is a wise reprover to a listening ear. (25:12)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("Like the cold of snow in the time of harvest")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("is a faithful messenger to those who send him;")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("he refreshes the soul of his masters. (25:13)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("Like snow in summer or rain in harvest,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("so honor is not fitting for a fool. (26:1)")])]), _vm._v(" "), _c('p', [_vm._v("Satire, the use of humour to express ridicule, is used to good effect in some of the proverbs about the ‘negative characters’ that appear in the book:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("As a door turns on its hinges,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("so does a sluggard in his bed. (26:14)")])]), _vm._v(" "), _c('p', [_vm._v("Paradox is also used to good effect, to make the reader stop and ponder a proverb:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("With patience a ruler may be persuaded,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("and a soft tongue will break a bone. (25:15)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("How can something soft break something hard?")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro11"
    }
  }, [_c('i', [_vm._v("Disjointed Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn38",
      "id": "fn38r"
    }
  }, [_vm._v("38")]), _vm._v(" has drawn attention to ‘disjointed proverbs’ in which there appears to be a misfit between the two cola because of what he calls a "), _c('i', [_vm._v("rhetorical gap,")]), _vm._v(" which is different from the grammatical gap to which the term ‘gapping’ is normally applied. In these proverbs either the premise or conclusion has been elided in one colon, or sometimes in both. By ‘premise’ he means ‘a principle or a fact on which a conclusion is based’. By ‘conclusion’ he means ‘the consequence of a behaviour defined in the premise or a rule drawn from it’. He discusses the following examples, among others:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p26"
    }
  }), _vm._v("A desire fulfilled is sweet to the soul,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but to turn away from evil is an abomination to fools. (13:19)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("At first reading the two cola seem unrelated. Their relationship becomes clear if one supplies the premise ‘fools desire evil’ for the second colon. It then becomes plain that the first colon is the reason why fools resist turning away from evil — they want to enjoy the sweetness of a desire fulfilled.")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("A fool despises his father’s instruction,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but whoever heeds reproof is prudent. (15:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The first colon describes a bad behaviour, but not its consequence. The consequence is implied by the second colon, it is the converse of the claim made in it. So, the fool who despises his father’s instruction will be imprudent.")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("The righteous hates falsehood,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but the wicked man brings shame and disgrace. (13:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The mismatch here is that the first colon speaks of an emotion and the second of a consequence. This awkwardness can be resolved by reversing what is said of the righteous to supply a premise for the second colon, and by reversing the consequence in the second colon to supply a conclusion for the first:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("The righteous hates falsehood "), _c('i', [_vm._v("and brings honor,")])]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("but the wicked "), _c('i', [_vm._v("loves falsehood")]), _vm._v(" and brings shame and disgrace.")])]), _vm._v(" "), _c('p', [_vm._v("Fox suggests that these ‘disjointed’ proverbs may be riddles, which the prologue of Proverbs (1:6) says studying the book will help readers to understand. If read and carefully thought through, the ‘disjointed’ proverbs not only convey truth, they train the reader in a mode of thinking. They encourage the identifying of behaviour patterns and the association of them with their consequences. They are a way of training the reader to think like ‘the wise’.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro05"
    }
  }, [_c('i', [_vm._v("Using Sentence Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The sentence proverbs are grounded in experience. They seem to arise from careful observation of life and the world. They are expressed in a brief, easy-to-remember form. Therefore the typical biblical Hebrew proverb can be defined as "), _c('i', [_vm._v("‘a reflection on life crystallised in a brief, memorable sentence’.")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p27"
    }
  }), _vm._v("It is important to recognise some limitations of the proverb as a means of communication and teaching, if it is not to be misused. A proverb arises out of a specific observation or experience and gains its meaning from that context. It is not a universally applicable truth. The reader has to intuit the appropriate context for a proverb. Maybe to remind readers of this the compilers of Proverbs occasionally put two ‘opposing’ proverbs together, for example Prov. 26:4-5:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Do not answer a fool according to his folly,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("lest you too become like him. (26:4)")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("Answer a fool according to his folly,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("lest he be wise in his own eyes. (26:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Proverbs have to be used wisely if they are to be of value (see on Prov. 26:1-12).")]), _vm._v(" "), _c('p', [_vm._v("Many biblical proverbs are simply observations of ‘the way it is’ and do not contain any explicit evaluation. The statement of a reality need not mean approval of it. It is important to compare proverb with proverb to get a ‘rounded’ view of what the wisdom teachers were saying.")]), _vm._v(" "), _c('p', [_vm._v("In expressing ‘the way things are’ proverbs are observations, not laws. They are "), _c('i', [_vm._v("describing the norm,")]), _vm._v(" not "), _c('i', [_vm._v("prescribing what must always happen")]), _vm._v(" or "), _c('i', [_vm._v("expressing the inevitable.")]), _vm._v(" Life and humans are too complex for a brief sentence to sum up all the truth about a given situation. Those who are wise will use proverbs with due discretion.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro06"
    }
  }, [_c('i', [_vm._v("Numerical Sayings")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Numerical sayings are not found in the extant wisdom literature from Mesopotamia and Egypt,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn39",
      "id": "fn39r"
    }
  }, [_vm._v("39")]), _vm._v(" though Roth"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn40",
      "id": "fn40r"
    }
  }, [_vm._v("40")]), _vm._v(" gives examples of the numerical sequence x/x+1 in parallel lines in Sumerian poetry and Akkadian incantations. There is one numerical saying in "), _c('i', [_vm._v("Ahiqar.")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn41",
      "id": "fn41r"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("There are two things which are good,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("and a third which is pleasing to Shamash:")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("one who drinks wine and shares it,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p28"
    }
  }), _vm._v("one who masters wisdom ["), _c('i', [_vm._v("and observes it")]), _vm._v("],")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("and one who hears a word but tells it not.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Because of its Assyrian setting, it has been widely assumed that the extant Aramaic version of the story of Ahiqar rests on an Akkadian original. In recent years, however, there has been a growing view that the Aramaic text is not a translation, but the original language. The case for an Aramaic original is particularly strong for the collection of sayings. They contain some Aramaic word-plays and few, if any, Akkadian loan words. Some also show a knowledge of West Semitic literary conventions."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn42",
      "id": "fn42r"
    }
  }, [_vm._v("42")]), _vm._v(" This leads Lindenberger to conclude that the proverbs in "), _c('i', [_vm._v("Ahiqar")]), _vm._v(" originated in northern Syria."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn43",
      "id": "fn43r"
    }
  }, [_vm._v("43")]), _vm._v(" There is an example of a numerical saying in the Ugaritic Baal epic."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn44",
      "id": "fn44r"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("Two sacrifices Baal abhors,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("three the charioteer of the Clouds:")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("a sacrifice of shame,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("and a sacrifice of whoredom,")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("and a sacrifice of the debauching of handmaidens.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("There are also examples of the numerical sequence x/x+1 in parallel lines in Ugaritic poetry."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn45",
      "id": "fn45r"
    }
  }, [_vm._v("45")]), _vm._v(" This has led to the suggestion that biblical numerical sayings may be a reflection of Canaanite influence."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn46",
      "id": "fn46r"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', [_vm._v("Roth"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn47",
      "id": "fn47r"
    }
  }, [_vm._v("47")]), _vm._v(" has done a detailed study of numerical sayings in the OT. The numerical saying has two constituents: the title line and the list. The title line describes or alludes to the feature or features which the items of the list have in common. There is no rigid form. The number may be anything, but 2, 3 and 7 are particularly common. Some poetical number sayings have the number in the title line in the form x/x+1. Roth calls these ‘graded numerical sayings’. They are in the majority in the Book of Proverbs.")]), _vm._v(" "), _c('p', [_vm._v("Numerical sayings are a form of list. Their distinctive feature is the use of a number in the title line. In reflective sayings the number is used as a device through which a discovered structural order in different phenomena in nature, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p29"
    }
  }), _vm._v("life, society, and so on, is defined. In hortatory sayings the number serves to fix a given number of requirements in the mind.")]), _vm._v(" "), _c('p', [_vm._v("The following numerical sayings occur in the Book of Proverbs.")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "ulf"
  }, [_vm._v("6:16-19 A hortatory graded numerical saying.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:11-14 Roth suggests that this is a reflection on society that has lost its numerical title line")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:15b-16 A graded numerical saying reflecting on natural phenomena grouped on the basis of insatiability.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:18-19. A graded numerical saying reflecting on phenomena in nature that are ‘too wonderful’ to be understood.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:21-23 A graded numerical saying reflecting on the order in society.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:24-28 A graded numerical saying reflecting on four small but wise creatures.")]), _vm._v(" "), _c('li', {
    staticClass: "ul"
  }, [_vm._v("30:29-31 A graded numerical saying reflecting on stately creatures.")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro06"
    }
  }, [_vm._v("Ancient Near Eastern Wisdom Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As archaeological discoveries increased our knowledge of the world within which the ancient Hebrews lived, it became clear that Hebrew wisdom literature was a specific example of a much wider, international phenomenon.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro07"
    }
  }, [_c('i', [_vm._v("Egyptian Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('i', [_vm._v("The Instruction of Hardjedef")]), _vm._v(" is thought to be the oldest extant Egyptian instruction, dating from about 2450-2300 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(" in the Old Kingdom Period."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn48",
      "id": "fn48r"
    }
  }, [_vm._v("48")]), _vm._v(" Hardjedef was the son of Cheops, builder of the Great Pyramid. The fragmentary text concerns setting up a household and funerary arrangements.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Instruction of Kagemni")]), _vm._v(" dates from the same period. It is addressed to Kagemni, a courtier, by an unnamed sage and gives instruction in correct behaviour in the presence of the king.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Instruction of Ptahhotep")]), _vm._v(" is the most important work from the Old Kingdom Period."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn49",
      "id": "fn49r"
    }
  }, [_vm._v("49")]), _vm._v(" Ptahhotep is said to be vizier under King Izezi, and the work instructs his son, whom he is preparing to follow him in that office. It has "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p30"
    }
  }), _vm._v("a prologue, thirty-seven maxims of varying length and an epilogue. It presents the ideal of a quiet, contented humble person, who is contrasted with the hot-tempered, anxious, striving person.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Instruction for King Merikari")]), _vm._v(" comes from the unsettled period between the Old and Middle Kingdoms, dating from about 2100 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn50",
      "id": "fn50r"
    }
  }, [_vm._v("50")]), _vm._v(" Merikari’s father counsels his son to be patient, to respect people and their property, to protect the powerless, to reject covetousness and favouritism, and to revere the gods and be punctilious in religious observances.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Instruction of Amenemhet")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn51",
      "id": "fn51r"
    }
  }, [_vm._v("51")]), _vm._v(" is presented as advice given by Pharaoh Amenemhet I to his son, who succeeded him after he had been assassinated following a palace coup ca. 1960 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(". It therefore appears to come from beyond the grave. Its main, pessimistic, message is not to trust anyone. The date of composition is unclear, but it was in existence prior to 1100 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("In "), _c('i', [_vm._v("The Instruction of Ani")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn52",
      "id": "fn52r"
    }
  }, [_vm._v("52")]), _vm._v(" (ca. 1580-1305 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v("), Ani, a scribe in the court of Queen Nefertari, wife of Pharaoh Ahmose, provides advice for his son on family life, avoiding strange women, religious observance, dealing honestly with people, remaining calm and composed. A remarkable epilogue contains a debate between Ani and his son Khonsuhotep about the methods and limits of education.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Instruction of Amenemope")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn53",
      "id": "fn53r"
    }
  }, [_vm._v("53")]), _vm._v(" (1250-1100 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(")"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn54",
      "id": "fn54r"
    }
  }, [_vm._v("54")]), _vm._v(" has attracted particular interest because of similarities with part of the Book of Proverbs (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#bhintro11"
    }
  }, [_vm._v("‘Proverbs 22:17–24:22 and "), _c('i', [_vm._v("The Instruction of Amenemope")]), _vm._v("’")]), _vm._v(" below). Its author came from the lower ranks of agricultural officials. The introduction sets out the purpose of the work: to provide training in how to be successful in the royal civil service. Its thirty chapters emphasise the value of a life of moderation and balance in which there is discernment of, and accommodation to, the divine purpose. It develops the contrast between the ‘silent man’ and the ‘heated man’, which is implicit in some earlier instructions.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The Instruction of Onchsheshonqy (Ankhsheshonqy)")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn55",
      "id": "fn55r"
    }
  }, [_vm._v("55")]), _vm._v(" purports to have been written in prison by a priest who was imprisoned because he was implicated in a palace revolt. It is an anthology of some 550 sayings of various kinds, loosely grouped more by format and tone than subject, and expresses strong religious sentiments. It presupposes a rural background rather than the royal court.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro08"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p31"
    }
  }), _c('i', [_vm._v("Mesopotamian Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('i', [_vm._v("The Instructions of Shuruppak")]), _vm._v(" is the oldest and most widely known Mesopotamian instruction. It is of Sumerian origin. The ‘standard version’ dates from 1900-1800 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(", but it is known from a version dated to about 2,500 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn56",
      "id": "fn56r"
    }
  }, [_vm._v("56")]), _vm._v(" It is named after the father of Ziusudra, the Sumerian equivalent of Noah, who gives his son rules of conduct and wise counsel to enable him to deal effectively with the problems and temptations of life.")]), _vm._v(" "), _c('p', [_vm._v("Alster has published twenty-eight collections of Sumerian proverbs. Although most are known from texts that date to the Old Babylonian period (1700-1600 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v("), he argues that some of the collections come from 2600-2550 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(". He summarises"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn57",
      "id": "fn57r"
    }
  }, [_vm._v("57")]), _vm._v(" the major topics they cover as, ‘a woman’s daily routine, family relationships, the good man, the liar, legal proceedings, Fate, the palace, the temples and their gods, as well as historical and ethnic allusions’.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("Counsels of Wisdom")]), _vm._v(" is a Babylonian collection written in Akkadian and dating from the Kassite period (1500-1200 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(")."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn58",
      "id": "fn58r"
    }
  }, [_vm._v("58")]), _vm._v(" The beginning is lost but at least part of it is addressed to ‘my son’. It contains advice on being guarded in speech, avoiding disputes, treating the poor considerately, avoiding women other than your wife, and acting with piety because it is both proper and beneficial.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro09"
    }
  }, [_c('i', [_vm._v("Aramaic Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The story of "), _c('i', [_vm._v("Ahiqar")]), _vm._v(" was known from the apocryphal book of Tobit, and in Syriac, Armenian and Arabic versions before an Aramaic version was found at Elephantine in Egypt in the early twentieth century in a papyrus which dates from the fifth century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(". The Aramaic text is fragmentary. It contains about a hundred sayings attached to a narrative about Ahiqar."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn59",
      "id": "fn59r"
    }
  }, [_vm._v("59")]), _vm._v(" The narrative tells the story of the disgrace and restoration of Ahiqar, an official in the court of the Assyrian king Sennacherib (704-681 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(") and his son Esarhaddon (680-669 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v("). It may have been composed in the seventh century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(". The collection of sayings, some of which may be older than the story, was attached to the story at some later date. Proverbs 23:13-14 is very similar to a saying"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn60",
      "id": "fn60r"
    }
  }, [_vm._v("60")]), _vm._v(" in "), _c('i', [_vm._v("Ahiqar.")])]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro10"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p32"
    }
  }), _c('i', [_vm._v("The Book of Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Clifford"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn61",
      "id": "fn61r"
    }
  }, [_vm._v("61")]), _vm._v(" helpfully summarises the main distinctives of the Book of Proverbs, apart from its theology, as compared to other ancient Near Eastern wisdom literature. Whereas the Egyptian instructions are addressed to a specific person, usually a courtier, the instructions in Prov. 1–9 are intended for a more general audience (Prov. 1:4-5). Compared to both the Egyptian and Mesopotamian instructions those in Proverbs are less specific. They urge readers to seek wisdom rather than to do specific actions. As Clifford puts it, ‘Proverbs emphasizes character rather than acts.’ In addition, the personification of Wisdom and Folly in these chapters and the vivid descriptions of her other opposites, deceptive men and the ‘strange woman’, create ‘a metaphorical level of discourse that was unknown in earlier wisdom literature’.")]), _vm._v(" "), _c('p', [_vm._v("The concise saying, or sentence proverb, has taken on a distinctive nature in the Book of Proverbs. The literary forms used are much less diverse than in the Mesopotamian and Aramaic collections. Also, nearly all the sayings in Prov. 10–31 are in the bicolon form, a sentence with two related halves.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro11"
    }
  }, [_c('i', [_vm._v("Proverbs 22:17–24:22 and")]), _vm._v(" The Instruction of Amenemope")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 1923 Budge"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn62",
      "id": "fn62r"
    }
  }, [_vm._v("62")]), _vm._v(" published the Egyptian ‘wisdom’ text which came to be known as "), _c('i', [_vm._v("The Instruction of Amenemope.")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn63",
      "id": "fn63r"
    }
  }, [_vm._v("63")]), _vm._v(" There was immediate recognition that it had a close relationship to a section of the Book of Proverbs: 22:17–24:22. The nature of the relationship has been a matter of some debate ever since.")]), _vm._v(" "), _c('p', [_vm._v("A wide range of possibilities have been proposed."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn64",
      "id": "fn64r"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nlf"
  }, [_vm._v("1. The author of Prov. 22:17ff. knew "), _c('i', [_vm._v("Amenemope")]), _vm._v(" and adapted it to suit his own purpose.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("2. The author of "), _c('i', [_vm._v("Amenemope")]), _vm._v(" knew Prov. 22:17ff. and made use of it.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("3. Both works are based on a now lost Egyptian original.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("4. Both works are based on a now lost Hebrew or Semitic original.")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("5. The two works are not directly connected, although they attest to a general affinity between Egyptian and Hebrew wisdom.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p33"
    }
  }), _vm._v("Although the date of the British Museum papyrus, sixth century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(", made the second option possible, the later discovery of other fragmentary copies of the work made it clear that it existed in the twelfth century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(","), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn65",
      "id": "fn65r"
    }
  }, [_vm._v("65")]), _vm._v(" so ruling out this option. This early date of the Egyptian work also makes it unlikely that a common Semitic original lies behind it and Prov. 22:17ff. The argument for this had been based primarily on alleged Semitisms in the text and attempts to explain some difficulties in it by appeal to the author’s poor translation of a Hebrew or Aramaic original. Williams"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn66",
      "id": "fn66r"
    }
  }, [_vm._v("66")]), _vm._v(" countered these claims and also pointed out some cases of paronomasia in "), _c('i', [_vm._v("Amenemope")]), _vm._v(" which could not have arisen if it were a translation rather than an original Egyptian work. Appeal to a lost common Egyptian original remains pure speculation, so the debate has settled around the first and last options in the list.")]), _vm._v(" "), _c('p', [_vm._v("Over the decades a wide, though by no means complete, agreement developed among both Egyptologists and biblical scholars that the author of Prov. 22:17ff. knew and made use of "), _c('i', [_vm._v("Amenemope.")]), _vm._v(" However, Whybray"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn67",
      "id": "fn67r"
    }
  }, [_vm._v("67")]), _vm._v(" strongly challenged this view. He deployed several lines of argument.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro12"
    }
  }, [_c('i', [_vm._v("Proverbs 22:20")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("He points out that a good deal has been made of the proposed emendation of this verse so that it refers to ‘thirty sayings’, corresponding to the thirty chapters of "), _c('i', [_vm._v("Amenemope.")]), _vm._v(" There is a Q/K variant in this verse. The Q is "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb11.jpg",
      "width": "36"
    }
  }), _vm._v(" "), _c('i', [_vm._v("(šālîšîm),")]), _vm._v(" which is a term denoting a military rank and, in Whybray’s view, clearly inappropriate in context. The K "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb12.jpg",
      "width": "43"
    }
  }), _vm._v(" "), _c('i', [_vm._v("(šlšwm)")]), _vm._v(" is usually vocalised as "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb13.jpg",
      "width": "37"
    }
  }), _vm._v(" "), _c('i', [_vm._v("(šilšôm).")]), _vm._v(" This occurs elsewhere only in the idiomatic phrase "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb14.jpg",
      "width": "57"
    }
  }), _vm._v(" "), _c('i', [_vm._v("(tĕmōl šilšôm),")]), _vm._v(" meaning ‘yesterday (and) the day before’, but having the sense of ‘in the past, formerly’. Whybray thinks that this makes good sense here. He assumes that the single word can stand for the full phrase, and appeals further to the presence of the temporal phrase ‘today’ in the preceding verse. As a result he sees no need for the widely accepted emendation to "), _c('i', [_vm._v("šĕlōšîm")]), _vm._v(" (‘thirty’), pointing out that one would expect it to be followed by the word ‘words’. He therefore sees no influence from "), _c('i', [_vm._v("Amenemope")]), _vm._v(" in this verse.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro13"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p34"
    }
  }), _c('i', [_vm._v("The Number of Units in Prov. 22:17–24:22")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Although some scholars have claimed to find thirty sayings in this section, in Whybray’s opinion their assessment is mistaken. He claims that they have counted as separate sayings verses that are really the introductions to admonitions (23:12, 19, 22-26; 24:3-4, 13-14). In his view there are not thirty separate units in this section of Proverbs.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro14"
    }
  }, [_c('i', [_vm._v("The structure of Prov. 22:17–24:22")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Whybray agrees with Niccacci"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn68",
      "id": "fn68r"
    }
  }, [_vm._v("68")]), _vm._v(" that 22:17–23:11 forms a single literary section containing ten admonitions. In Whybray’s view the sayings in 23:12–24:22 have not been organised into a single literary unit. They contain diverse material and have been added to 22:17–23:11 piecemeal as unconnected appendices. This, he thinks, militates against the suggestion that the whole section is in some way modelled on "), _c('i', [_vm._v("Amenemope.")])]), _vm._v(" "), _c('p', [_vm._v("The thematic parallels with "), _c('i', [_vm._v("Amenemope")]), _vm._v(" are confined to 22:17–23:11. Throughout 22:17–24:22 there are thematic, and even verbal, affinities with the instructions in Prov. 1–9.")]), _vm._v(" "), _c('p', [_vm._v("Some Egyptologists have expressed doubts about the closeness of the connection between the two texts.")]), _vm._v(" "), _c('p', [_vm._v("Emerton"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn69",
      "id": "fn69r"
    }
  }, [_vm._v("69")]), _vm._v(" has made a detailed critique of Whybray’s arguments.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro15"
    }
  }, [_c('i', [_vm._v("Proverbs 22:20")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Whybray’s interpretation faces problems. The first is his assumption that the word "), _c('i', [_vm._v("šilšôm")]), _vm._v(" can mean ‘formerly’ on its own. There is no evidence for this."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn70",
      "id": "fn70r"
    }
  }, [_vm._v("70")]), _vm._v(" Second, there is the fact that none of the versions reads the word before them as meaning this. Finally, it creates the difficulty that the sage is then referring to an earlier private document not available to the readers of the wisdom book. There is no other example of this in the extant wisdom literature. The LXX, Vulg, Syr and Targ all have words meaning ‘three times’ here, suggesting that they read the Hebrew as the word "), _c('i', [_vm._v("šĕlīšîm,")]), _vm._v(" which occurs in Gen. 6:16; Num. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p35"
    }
  }), _vm._v("2:24; 1 Sam. 19:21; and 2 Kgs. 1:13 as the masculine plural of the ordinal number ‘third’. This implies that the consonantal text before them was that of the Q, "), _c('i', [_vm._v("šlyšym")]), _vm._v(" or possibly "), _c('i', [_vm._v("šlšym,")]), _vm._v(" as in Gen. 6:16 and so on. The shorter reading could explain the K since in some forms of the Hebrew script "), _c('i', [_vm._v("yodh")]), _vm._v(" and "), _c('i', [_vm._v("waw")]), _vm._v(" are easily confused. Thus a plausible case can be made for "), _c('i', [_vm._v("šĕlōšîm")]), _vm._v(" on text-critical grounds. Whybray’s objection, that it ought to have been followed by the word ‘words’, is not a strong one. In Hebrew, specifications of measure, weight or time are commonly omitted after numerals."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn71",
      "id": "fn71r"
    }
  }, [_vm._v("71")]), _vm._v(" The same is true of the word ‘things/items’ in 2 Sam. 24:12 and, more pertinently, in Prov. 30:7, 15, 18, 21, 29. Whybray’s comment that the Q does not make sense in context is valid, but the emendation to ‘thirty (things/items)’, requiring only a small and understandable consonantal change in the text, makes more sense than the K that he defends.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro16"
    }
  }, [_c('i', [_vm._v("The Number of Units in Proverbs 22:17–24:22")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Emerton examines the analyses presented by several scholars who do find thirty units in this section of Proverbs. Like Niccacci and Whybray they all find ten units in 22:22–23:11. There is also general agreement, including by Whybray, that 24:13-22 contains five units. With regard to 23:12–24:12 Emerton concludes that the most probable analyses of this section lead to dividing it into fourteen or fifteen units, giving a total of twenty-nine or thirty in the section as a whole. Hence there is no basis for Whybray’s confident assertion that there are not thirty units here.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro17"
    }
  }, [_c('i', [_vm._v("The Structure of Proverbs 22:17–24:22 and the Thematic Parallels with")]), _vm._v(" Amenemope")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Whybray’s case with regard to these two issues rests on the assumption that the author of this section of Proverbs intended to produce a work closely modelled on the Egyptian text. However, most of the scholars who have argued for the influence of "), _c('i', [_vm._v("Amenemope")]), _vm._v(" on this section of Proverbs have not argued for that. They have argued that the author was seeking to produce his own ‘wisdom book’ in Hebrew under the influence of the Egyptian text, but drawing on other sources also. In the choice and ordering of the material he had his own aims in mind. Neither the concentration of material parallel to "), _c('i', [_vm._v("Amenemope")]), _vm._v(" in 22:17–24:11 nor the diversity of material in the rest of the section militates against this view.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro18"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p36"
    }
  }), _c('i', [_vm._v("The Views of Egyptologists")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Whybray refers to a few Egyptologists who have expressed doubts about a direct relationship between this section of Proverbs and "), _c('i', [_vm._v("Amenemope.")]), _vm._v(" However, the only detailed discussion he refers to is that by Ruffle."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn72",
      "id": "fn72r"
    }
  }, [_vm._v("72")]), _vm._v(" Emerton examines Ruffle’s arguments against dependence and finds them unconvincing. A major reason for this is that Ruffle works with the assumption that ‘dependence’ means that the Hebrew text ought to be a fairly literal translation of the Egyptian. This is not what has been generally advocated.")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro19"
    }
  }, [_c('i', [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The kind of theory originally advance by Gressmann,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn73",
      "id": "fn73r"
    }
  }, [_vm._v("73")]), _vm._v(" and subsequently taken up and developed by other scholars, that Prov. 22:17–24:22 is a work influenced by "), _c('i', [_vm._v("Amenemope,")]), _vm._v(" but which treats the Egyptian work freely, omitting much that is in it and adding material from elsewhere, is still plausible. Recently Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn74",
      "id": "fn74r"
    }
  }, [_vm._v("74")]), _vm._v(" has suggested how the ‘author-editor’ of Prov. 22:17–23:11 ‘worked by scrolling forward and back in the source papyrus, each time picking up material of interest to him and reshaping it in accordance with his goals.’")]), _vm._v(" "), _c('h4', {
    staticClass: "ch",
    attrs: {
      "id": "chintro20"
    }
  }, [_c('i', [_vm._v("An Analysis of Proverbs 22:17–24:22")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As noted above, there is general agreement about the ten sayings in 22:22–23:11 and the five in 24:13-22. There is considerable agreement in recognising introductions to instructions in 23:12, 19, 26, and somewhat less so regarding 23:15 (see the list on "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#p37"
    }
  }, [_vm._v("p. 37")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Units 1-10 are marked out by the recurring use of ‘Do not’, often at the beginning of the saying. The same is true of units 27-29. The use of ‘My son’ marks out the beginning of units 13, 14, 16, 26, 30. New units are clearly introduced in 23:12 (unit 11) and 23:22 (unit 15). The identification of units 11-16 and 26-30 is reasonably clear. The identification of units 17-25 is more debatable.")]), _vm._v(" "), _c('p', [_vm._v("The theme of 23:29-35 is drunkenness, and it could be regarded as one unit for this reason. There is a clear link between vv. 29 and 30, since v. 30 answers the questions asked in v. 29. Although it is arguable that the ‘Do not’ of v. 31 "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p37"
    }
  }), _vm._v("introduces a new unit, it follows on very well from vv. 29-30, and it is plausible to see one unit here (unit 17): an instruction consisting of an introduction (a riddle with its answer) followed by an admonition and motive.")]), _vm._v(" "), _c('section', {
    staticClass: "list"
  }, [_c('h1', {
    staticClass: "nlh"
  }, [_vm._v("Introduction: 22:17-21")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nl"
  }, [_vm._v("1. 22:22-23")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("2. 22:24-25")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("3. 22:26-27")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("4. 22:28")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("5. 22:29")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("6. 23:1-3")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("7. 23:4-5")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("8. 23:6-8")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("9. 23:9")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("10. 23:10-11")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("11. 23:12")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("12. 23:13-14")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("13. 23:15-18")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("14. 23:19-21")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("15. 23:22-25")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("16. 23:26-28")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("17. 23:29-35")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("18. 24:1-2")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("19. 24:3-4")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("20. 24:5-6")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("21. 24:7")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("22. 24:8")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("23. 24:9")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("24. 24:10")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("25. 24:11-12")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("26. 24:13-14")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("27. 24:15-16")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("28. 24:17-18")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("29. 24:19-20")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("30. 24:21-22")])])]), _vm._v(" "), _c('p', [_vm._v("There is general agreement that 24:1-2 is a single unit (unit 18). There is disagreement about 24:3-7, which has the general theme of wisdom. However, vv. 3-4 and v. 7 speak of ‘wisdom’ itself whereas vv. 5-6 speaks of the wise person. This suggest that here there are three separate units (units 19-21).")]), _vm._v(" "), _c('p', [_vm._v("The next two verses have the common theme of planning evil. They can be taken either as a single unit or as two separate sayings linked by the catch words ‘schemer/schemes’. Since each sentence could stand on its own as a proverb the latter view is plausible (units 22-23).")]), _vm._v(" "), _c('p', [_vm._v("It would be possible to divide the next three verses into either one, two or three sayings. The imperative that opens v. 11 could be the beginning of an instruction, and v. 12 seems to be dependent on it since the ‘If …’ at its beginning makes most sense if it refers back to the previous verse. Because v. 10 makes sense as a complete saying on its own, it is reasonable to see two units here (units 24-25), which are loosely connected by the possibility that v. 11 refers to one example of the ‘times of trouble’ mentioned in v. 10.")]), _vm._v(" "), _c('p', [_vm._v("Waltke"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn75",
      "id": "fn75r"
    }
  }, [_vm._v("75")]), _vm._v(" argues that 22:17-21 should be counted as the first saying. The basis of his argument is that in "), _c('i', [_vm._v("Amenemope")]), _vm._v(" the introduction, which has material "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p38"
    }
  }), _vm._v("comparable to Prov. 22:17-21, is counted as the first chapter. He then takes 24:10-12 as a single saying. We have argued above that it is better to take this as two sayings and that this section of Proverbs is only loosely modelled on "), _c('i', [_vm._v("Amenemope.")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro07"
    }
  }, [_vm._v("The Origin of Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("For much of the twentieth-century it was generally maintained that the book of Proverbs, and much of its content, originated among scribal circles associated with the royal court in Jerusalem. The references to Solomon in Prov 1:1 and 10:1 and to the activity of Hezekiah’s men collecting Solomonic proverbs in 25:1 seemed to point in this direction. The discovery of links with "), _c('i', [_vm._v("Amenemope")]), _vm._v(" gave weight to this view because of the perceived connection between Egyptian instructions and the Egyptian court. By analogy with the situation in Egypt and Mesopotamia it was assumed that there were ‘wisdom schools’ in Israel and Judah for training scribes and maybe other courtiers, particularly in connection with the court and temple in Jerusalem. Collections of proverbs, it was argued, would have been used for teaching in this context. Malchow’s"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn76",
      "id": "fn76r"
    }
  }, [_vm._v("76")]), _vm._v(" argument that Prov. 27:23–29:27 is ‘a manual for future monarchs’ could be seen to support this.")]), _vm._v(" "), _c('p', [_vm._v("However, as early as 1913 Eissfeldt"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn77",
      "id": "fn77r"
    }
  }, [_vm._v("77")]), _vm._v(" suggested that Proverbs includes some popular sayings that had originally been transmitted orally. He argued that the book contains some single-line proverbs which were ‘folk proverbs’ but were later expanded into two-line ‘wisdom sayings’. There is some support for this in the presence of the narrative books of the OT of such single-line sayings (e.g. 1 Sam. 24:14; 1 Kgs 20:11). Scott"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn78",
      "id": "fn78r"
    }
  }, [_vm._v("78")]), _vm._v(" later came to much the same conclusions. Westermann"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn79",
      "id": "fn79r"
    }
  }, [_vm._v("79")]), _vm._v(" too argued that the much of the material in Prov. 10:1–22:16 and 25–29 has its roots in orally transmitted Israelite folk wisdom. He suggested that the level of cultural development in its tribal, pre-monarchic, period was comparable to that of other pre-literate, tribal cultures, especially African ones, whose proverbs have been collected, and so made available for study.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro12"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p39"
    }
  }), _c('i', [_vm._v("African Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One of Westermann’s students, Golka, carried out some comparative studies of biblical and African proverbs."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn80",
      "id": "fn80r"
    }
  }, [_vm._v("80")]), _vm._v(" In one such study he compared the proverbs that refer to the powers and functions of rulers (kings and chiefs) in the Hebrew and African collections. He argued that the interests and sentiments expressed in these ‘royal proverbs’ indicated that they were not the product of the royal court or of royal scribes but of the common people who observed what went on in the court but did not participate in it. In a wider study he concluded that the African and Hebrew proverbs evidenced much the same concerns. He noted two differences between the two collections of proverbs. There was a lack of any religious element in the African proverbs, except where there was Islamic influence. On the other hand, African traditional proverbs played a part in the administration of justice. They may have been used to support an argument and influence legal decisions.")]), _vm._v(" "), _c('p', [_vm._v("Naré"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn81",
      "id": "fn81r"
    }
  }, [_vm._v("81")]), _vm._v(" compared the oral proverbs of the Mossi of Upper Volta with Prov. 25–29. He found that, unlike the material studied by Golka, the religious element was not lacking. The religion of the Mossi is monotheistic, based on belief in a God who created the world and is benevolent and just.")]), _vm._v(" "), _c('p', [_vm._v("Part of the case put forward by both Westermann and Golka is the argument that the origin of most of the proverbs in chs. 10–29 should be located among the ‘simple people’ in agrarian villages. Whybray"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn82",
      "id": "fn82r"
    }
  }, [_vm._v("82")]), _vm._v(" took a similar position. Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn83",
      "id": "fn83r"
    }
  }, [_vm._v("83")]), _vm._v(" challenges this, arguing that while some of the proverbs may have originated in this setting, it is not the dominant background of the book. He points to proverbs that, he says, these scholars have overlooked, which have references to an urban setting and people of some wealth, such as goldsmithery (17:3; 27:21), fine jewellery (25:11-12), messengers (10:26; 22:21; 25:13), the disciplining of slaves (29:21) and those able to store and distribute considerable stocks of grain (11:26). Fox also disputes Golka’s view that the ‘royal proverbs’ express the outlook of the common people. He argues that many proverbs that Golka regards as being deeply critical of the king do no more than recognise the power of the king, and the damage as well as the good that it can do. Moreover, he says, there is no reason why those close to kings shouldn’t see them with critical eyes. Fox calls for a recognition of the diversity of sources and backgrounds of the proverbs.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p40"
    }
  }), _vm._v("Loader"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn84",
      "id": "fn84r"
    }
  }, [_vm._v("84")]), _vm._v(" has critically reviewed Golka’s work. He argues that Golka’s study is biased by his ideological preference for locating the origin of the proverbs among the ‘little people’ rather than the elite in society. In addition he points out that both Golka and Westermann simply assume that schools did not exist in traditional African tribal cultures. He challenges this assumption, while pointing out that such schools might be quite different from the modern European conception of a school. Nonetheless they provide an institutional didactic setting in which proverbs would have a place. Perhaps most importantly, he challenges Golka’s interpretation of many of the African and biblical ‘royal proverbs’. He argues that Golka too readily concludes that they are critical of the king or court and that they could not come from those close to the king. In his view Golka has gone too far in the other direction in seeking to counter a one-sided association of the Hebrew proverbs with the royal court.")]), _vm._v(" "), _c('p', [_vm._v("Golka"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn85",
      "id": "fn85r"
    }
  }, [_vm._v("85")]), _vm._v(" has responded to Loader’s criticisms. The main point in his response is that in his interpretation of the African proverbs he usually relied on the explanation of their meaning given by those who collected them. Sometimes, he said, this explanation was ‘surprising’ to him, and he accepted that some of them, maybe 20 per cent, might be wrong. Nevertheless he stood by his overall conclusions.")]), _vm._v(" "), _c('p', [_vm._v("This exchange highlights the need for more depth in comparative studies before reliable conclusions can be drawn. Loader is right to point to the need to investigate what cultural institutions and settings there might be in tribal cultures for the creation and transmission of proverbs. He also makes clear the problem facing biblical scholars of how to arrive at the meaning of a proverb from a different culture with any confidence when they have no expert knowledge of the languages and cultures concerned.")]), _vm._v(" "), _c('p', [_vm._v("Kimilike’s"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn86",
      "id": "fn86r"
    }
  }, [_vm._v("86")]), _vm._v(" work on proverbs about poverty from an African perspective is discussed in the essay "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0014#ah0206"
    }
  }, [_vm._v("‘Wealth and Poverty in Proverbs.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro13"
    }
  }, [_c('i', [_vm._v("Arabic Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Kassis"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn87",
      "id": "fn87r"
    }
  }, [_vm._v("87")]), _vm._v(" has made a detailed comparative study of Arabic and biblical proverbs. He classifies the Arabic proverbs as ‘classical’, ‘post-classical’ and ‘current’. The classical period includes the pre-Islamic and early Islamic eras, before the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p41"
    }
  }), _vm._v("expansion of Arabs into other countries and cultures. He admits that the distinction between classical and post-classical proverbs is sometimes not an easy one to make. By ‘current’ proverbs he means those collected by missionaries, orientalists and nationals since the beginning of the nineteenth century. These proverbs may be expressed in either colloquial or classical Arabic, and are not necessarily of recent origin.")]), _vm._v(" "), _c('p', [_vm._v("Kassis shows that there is considerable similarity in both form and content between the Arabic and biblical proverbs in Prov. 10:1–22:16 and 25–29, as well as some notable differences. Perhaps one of the most interesting parts of his study it that concerning ‘royal proverbs’. He shows that in Arabic this kind of proverb was often used for propagandist purposes, both to support the authority or policies of the Caliph and to foment opposition to them, even rebellion. The proverbs of the later kind, he argues, clearly had their origin among the religious leaders or the common people. However, not all proverbs critical of the Caliph or his court originated among opponents of the ruler. Some originated with rulers themselves, or in their court. A Caliph might produce a proverb that is critical of rulers to express his humility, or to show his compassion and identification with his subjects, perhaps by referring to their sufferings under other unjust rulers. Kassis concludes that his study shows a diversity of origins and functions of royal proverbs. Whether or not a saying is favourable towards, or critical of, the ruler or court is no sure guide to its origin. In his view it is wrong to regard all the royal proverbs as either the product of the court or of the common people.")]), _vm._v(" "), _c('p', [_vm._v("This study shows the importance of comparing the biblical proverbs with those from more than one culture. Even if Golka’s conclusion about royal proverbs in African tribal culture is accepted, Kassis’ study shows that things can be different in another culture. This, of course, raises another important issue — which culture is the more appropriate ‘model’ on the basis of which to understand the biblical material. In favour of giving priority to the Arabic evidence is the closeness geographically, linguistically and culturally between the Arabs and the Hebrews. Part of this closeness is that the extant Arabic proverbs, like those in the Book of Proverbs, cover the transition from a tribally-based culture to a monarchical one.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro14"
    }
  }, [_c('i', [_vm._v("The Compilation of the Book of Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Van Leeuwen"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn88",
      "id": "fn88r"
    }
  }, [_vm._v("88")]), _vm._v(" makes the point that it is important to make clear distinctions between:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nlf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p42"
    }
  }), _vm._v("1. the original "), _c('i', [_vm._v("sources")]), _vm._v(" of proverbs and collections (whether oral or written);")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("2. the "), _c('i', [_vm._v("persons, processes,")]), _vm._v(" and "), _c('i', [_vm._v("places")]), _vm._v(" of literary collection;")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_vm._v("3. the editorial "), _c('i', [_vm._v("composition")]), _vm._v(" of collections;")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("4. the final editing of the Book of Proverbs into the form in which we have it.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Sometimes the debate between those advocating a ‘folk’ origin of proverbs and those favouring a ‘school’ origin has been confused by the failure to recognise these distinctions.")]), _vm._v(" "), _c('p', [_vm._v("The conclusion to be drawn from the debate so far seems to be the need to recognise a diversity of origins for the material in Proverbs. Most scholars seem to accept that some of the proverbs have a ‘folk’ origin. There is then the problem of how to discern these within the extant collection. Eissfeldt, Scott and Westermann all argued that the original folk proverbs were short, one-line sayings and that some of these can be identified in the Book of Proverbs. Williams"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn89",
      "id": "fn89r"
    }
  }, [_vm._v("89")]), _vm._v(" recognises the difficulty in doing this:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Of course, it is not always easy to discern whether or not one has a folk saying which has been expanded with the addition of a literary line, or whether it is a really clever folk saying or perhaps a literary creation which the composer has sought to make ‘folkish’.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("One approach has been to identify two-line proverbs that have one line in common (e.g. 10:2/11:4; 10:6/10:11; 10:15/18:11). However, there is no guarantee that the common line was originally a folk proverb. It is conceivable that the variant proverbs are the result of a deliberate alteration of an original two-line proverb. Kassis"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn90",
      "id": "fn90r"
    }
  }, [_vm._v("90")]), _vm._v(" argues that there is evidence of the literary development of short sayings in the transmission of Arabic proverbs. He then suggests that finding similar sayings between Hebrew and Arabic proverbs might be a way of identifying original one-line sayings. However, he admits that there is a possible problem in that the similarity might be the result of literary influence one way or the other rather than a common folk saying. There seems to be good grounds for Murphy’s comment"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn91",
      "id": "fn91r"
    }
  }, [_vm._v("91")]), _vm._v(" that, ‘it is extremely difficult to make a case for certain sayings as having been popular proverbs before they were collected for the book of Proverbs’.")]), _vm._v(" "), _c('p', [_vm._v("Whatever the initial origin of the proverbs in the Book of Proverbs, we "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p43"
    }
  }), _vm._v("have seen that there is evidence that the book as we have it is a compilation of a number of pre-existing collections. Who was responsible for the collections and for the final compilation? The evidence for the existence of ‘wisdom schools’ in ancient Israel and Judah is inconclusive."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn92",
      "id": "fn92r"
    }
  }, [_vm._v("92")]), _vm._v(" However, in any case, as Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn93",
      "id": "fn93r"
    }
  }, [_vm._v("93")]), _vm._v(" comments, ‘there is nothing in Proverbs to point to a school origin’. Rather, as is pointed out in the commentary on Prov. 1:8-9, the evidence in the book itself suggests the home as the place of instruction. Nor is there much evidence that this instruction was aimed primarily at future courtiers. Despite Malchow’s argument, the fact is that, according to Humphreys,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn94",
      "id": "fn94r"
    }
  }, [_vm._v("94")]), _vm._v(" there are only about 30 of the 538 sayings in Prov. 10–29 which seem addressed primarily to the courtier. If the home was the place where much of the material in Proverbs was collected and shaped, it was in a particular type of home. The literary quality of many of the sentence proverbs and of the more complex instruction form found particularly, but not solely, in Prov. 1–9, suggests the activity of professional teachers. In Sandoval’s"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn95",
      "id": "fn95r"
    }
  }, [_vm._v("95")]), _vm._v(" view, ‘It is difficult to imagine the production (and use) of such didactic collections of proverbs, and certainly an anthology of such collections (a book), in anything other than an elite intellectual environment.’ He suggests that the book is the product of a scribal elite. Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn96",
      "id": "fn96r"
    }
  }, [_vm._v("96")]), _vm._v(" comes to a similar conclusion, and, using the phraseology of Prov. 25:1, he says, ‘we may designate the authors and redactors "), _c('i', [_vm._v("the king’s men.")]), _vm._v(" This term is preferable to the usual "), _c('i', [_vm._v("courtier,")]), _vm._v(" which connotes wealth and nobility.’ These ‘king’s men’ need not have been particularly high ranking scribes, close to the inner court circles. Whybray"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn97",
      "id": "fn97r"
    }
  }, [_vm._v("97")]), _vm._v(" points out that many of the Egyptian instructions came from scribes of fairly low rank. The author of "), _c('i', [_vm._v("Amenemope")]), _vm._v(" was a scribe of middle, or even lower, social and professional rank. The ‘job titles’ invoked in it all belong to the middle or lower level of bureaucratic positions."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn98",
      "id": "fn98r"
    }
  }, [_vm._v("98")]), _vm._v(" Within Israel these ‘learned clerks’, as Fox calls them, would have formed a distinct social class, separate from the politically and economically powerful, the urban artisans and the majority rural population. Because of the variety of administrative tasks that they would have fulfilled as a result of their literacy, they would have the opportunity to observe and learn from the behaviour and experience of other groups in Israelite society. As Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn99",
      "id": "fn99r"
    }
  }, [_vm._v("99")]), _vm._v(" comments, this would account for ‘the great diversity and even greater "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p44"
    }
  }), _vm._v("unity in Proverbs. The diversity comes from the varied sources, the unity from the redactors’ own creative activity.’ These sages developed their own worldview they present in the material which they have selected to include in the Book of Proverbs. They present it in a way which is didactic and relatively unpolemical. Some scholars compare the rhetoric of Proverbs unfavourably with the fiery rhetoric of the prophets, but there is more than one way of seeking to shape society. In Proverbs the sages seek to do it by education.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerlucas0006#rahintro08"
    }
  }, [_vm._v("Texts and Versions")])]), _vm._v(" "), _c('h3', {
    staticClass: "bhaft",
    attrs: {
      "id": "bhaftintro01"
    }
  }, [_c('i', [_vm._v("Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In many places the MT of Proverbs is free of problems. However, in some places, especially in the ‘sentence literature’, there are numerous obscurities. These may be the result of the use of rare words — a feature of Hebrew poetry with its frequent use of parallelism. When the only context of a word is a single, brief proverb it is often not easy to determine the meaning. Scholars therefore sometimes resort to comparative philology to suggest meanings based on cognate words in other Semitic languages. This is always a somewhat hazardous approach. Another likely source of some obscurities is copying error.")]), _vm._v(" "), _c('p', [_vm._v("Two mss from Qumran contain small portions of Proverbs."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn100",
      "id": "fn100r"
    }
  }, [_vm._v("100")]), _vm._v(" 4Q102 (= 4QProv"), _c('sup', [_vm._v("a")]), _vm._v(", late first century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(") contains parts of Prov. 1:27–2:1. 4Q103 (= 4QProv"), _c('sup', [_vm._v("b")]), _vm._v(", mid-first century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AD")]), _vm._v(") contains fragments of Prov. 13–15. The Hebrew text of these mss is very close to that of the MT.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro15"
    }
  }, [_c('i', [_vm._v("Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The LXX translation of Proverbs is generally dated to the second half of the second century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BC")]), _vm._v(", though Cook"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn101",
      "id": "fn101r"
    }
  }, [_vm._v("101")]), _vm._v(" dates it a bit earlier.")]), _vm._v(" "), _c('p', [_vm._v("One obvious feature of the LXX of Proverbs is its ordering of the text. Besides some minor variations, there is a major difference in the sequence of the sections after 24:22. Following the Hebrew numbering, the sequence is: 30:1-14; 24:23-34; 30:15-33; 31:1-9; 25:1–29:27; 31:10-31 (with vv. 25-26 in reverse order). The MT order makes sense from a literary point of view. It keeps the sentence literature together in chs. 10-29 and puts a number of short sections of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p45"
    }
  }), _vm._v("various forms and authorship together in chs. 30-31 as ‘appendices’. It is hard to find a rationale for the LXX order. The different order in the MT and the LXX may indicate that these units originally circulated as independent collections.")]), _vm._v(" "), _c('p', [_vm._v("The LXX of Proverbs contains about 130 couplets and thirty partial sentences not present in the MT."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn102",
      "id": "fn102r"
    }
  }, [_vm._v("102")]), _vm._v(" On the other hand, it omits about twenty-five verses found in the MT."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn103",
      "id": "fn103r"
    }
  }, [_vm._v("103")]), _vm._v(" Some of the extra material occurs in ‘doublets’. Fritsch"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn104",
      "id": "fn104r"
    }
  }, [_vm._v("104")]), _vm._v(" counted about seventy-six of these. They seem to be the result of a more literal rendering of the Hebrew being added to correct a translation that was thought to be too free or inaccurate. Snell"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn105",
      "id": "fn105r"
    }
  }, [_vm._v("105")]), _vm._v(" suggests that some of the omissions are due to the translator omitting proverbs, or parts of proverbs, that are repeated in the MT.")]), _vm._v(" "), _c('p', [_vm._v("Scholars differ in their assessment of just how ‘free’ the original LXX translation was. Gerleman"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn106",
      "id": "fn106r"
    }
  }, [_vm._v("106")]), _vm._v(" characterised it as ‘numbered among the free, sometimes paraphrasing versions’. Cook"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn107",
      "id": "fn107r"
    }
  }, [_vm._v("107")]), _vm._v(" took a similar view, concluding that the LXX of Proverbs should be seen as an ‘exegetical writing’.")]), _vm._v(" "), _c('p', [_vm._v("Clifford"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn108",
      "id": "fn108r"
    }
  }, [_vm._v("108")]), _vm._v(" came to a different conclusion. While accepting that the LXX of Proverbs is a fairly free translation, in his view the primary intent of the translator was to render the Hebrew text as accurately as possible, with a ‘word for word’ translation often being attempted. Fox,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn109",
      "id": "fn109r"
    }
  }, [_vm._v("109")]), _vm._v(" in a direct response to Cook, argues that although there are some elements of exegesis in the LXX, they are rarely tendentious. In his view, when its tendency to moralise is allowed for, and the obvious additions and expansions set aside, the LXX translation is a fairly faithful rendering of the original Hebrew. With regard to textual criticism, Fox is more ready than Cook,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn110",
      "id": "fn110r"
    }
  }, [_vm._v("110")]), _vm._v(" who urges ‘utmost caution’, to turn to the LXX for evidence of underlying textual variants in the Hebrew.")]), _vm._v(" "), _c('p', [_vm._v("Scholars differ over whether or not the LXX gives evidence of a different recension of the Hebrew text from the MT. McKane"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn111",
      "id": "fn111r"
    }
  }, [_vm._v("111")]), _vm._v(" argues that there is no evidence for this, and Cook"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn112",
      "id": "fn112r"
    }
  }, [_vm._v("112")]), _vm._v(" agrees. However, Tov"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn113",
      "id": "fn113r"
    }
  }, [_vm._v("113")]), _vm._v(" argues that the LXX of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p46"
    }
  }), _vm._v("Proverbs is based on a Hebrew recension that was parallel to, but different from, that behind the MT. Fox"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn114",
      "id": "fn114r"
    }
  }, [_vm._v("114")]), _vm._v(" agrees.")]), _vm._v(" "), _c('p', [_vm._v("The conclusion to be drawn from this discussion is that, once non-textual reasons for different renderings have been taken into account, a small number of variants do remain that need to be considered seriously on a case-by-case basis as possible evidence of a different Hebrew text from that preserved in the MT.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro16"
    }
  }, [_c('i', [_vm._v("Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The Peshitta translation was made in the second century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AD")]), _vm._v(". It is a fairly literal translation of the Hebrew text, while also showing strong influence from the LXX. It omits most of the additional material in the LXX and follows the order of the Hebrew text.")]), _vm._v(" "), _c('p', [_vm._v("The Syr can be evidence for a textual variant when it diverges from both the MT and the LXX or when it can be back-translated to give the same reading as the LXX, but treats it differently.")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro17"
    }
  }, [_c('i', [_vm._v("Aramaic")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The Targ to Proverbs stands out from the other Targumim to the Hagiographa because of its total lack of haggadic and midrashic expansions. There is a general, though not universal, consensus that the Targ of Proverbs is directly dependent on the Syr text. When the Targ diverges from the Syr this can usually be explained by an attempt to render the Hebrew text more literally. The Hebrew text used was very similar to the MT. Numerous agreements between the Targ and the LXX are generally taken to be the result of the reliance of the Targ on the Syr. It is rarely taken as of value in text-criticism.")]), _vm._v(" "), _c('p', [_vm._v("Those who accept that it makes use of the Syr have suggested dates for the Targ from the third to the eighth century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AD")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "bh",
    attrs: {
      "id": "bhintro18"
    }
  }, [_c('i', [_vm._v("Latin")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Jerome translated a Hebrew text of Proverbs very close to the consonantal MT into Latin in 398 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AD")]), _vm._v(". This work was incorporated into the Vulg. He made use "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p47"
    }
  }), _vm._v("of the LXX and also of the more literal translations into Greek of Aq, Theod and Sym. Although he also knew the Syr, he rarely followed it rather than the Greek versions. At times he seems to draw on traditional rabbinic or Christian exegesis to make sense of those proverbs with which the Greek translators struggled with only partial success.")]), _vm._v(" "), _c('p', [_vm._v("Clifford"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/#fn115",
      "id": "fn115r"
    }
  }, [_vm._v("115")]), _vm._v(" notes that ‘Jerome had direct access to important textual witnesses (some no longer extant) and had the training and talent to use them properly.’ Therefore, when the Vulg of Proverbs occasionally differs from the MT, or supports another version against the MT, it should be given serious consideration.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn1r",
      "id": "fn1"
    }
  }, [_vm._v("1.")]), _vm._v(" Whybray, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 4.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn2r",
      "id": "fn2"
    }
  }, [_vm._v("2.")]), _vm._v(" Whybray, "), _c('i', [_vm._v("Intellectual Tradition of the Old Testament,")]), _vm._v(" 8.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn3r",
      "id": "fn3"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('i', [_vm._v("NIDOTTE")]), _vm._v(" 2:1134-37.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn4r",
      "id": "fn4"
    }
  }, [_vm._v("4.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 54-55.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn5r",
      "id": "fn5"
    }
  }, [_vm._v("5.")]), _vm._v(" This was first pointed out by Whybray, "), _c('i', [_vm._v("Wisdom in Proverbs.")]), _vm._v(" Hesitations about this analysis are expressed by Murphy, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 8-9.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn6r",
      "id": "fn6"
    }
  }, [_vm._v("6.")]), _vm._v(" Luc, ‘Titles and Structure of Proverbs’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn7r",
      "id": "fn7"
    }
  }, [_vm._v("7.")]), _vm._v(" Skladny, "), _c('i', [_vm._v("Ältesten Spruchsammlungen in Israel.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn8r",
      "id": "fn8"
    }
  }, [_vm._v("8.")]), _vm._v(" Waltke, "), _c('i', [_vm._v("Proverbs 1–15,")]), _vm._v(" 16.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn9r",
      "id": "fn9"
    }
  }, [_vm._v("9.")]), _vm._v(" Toy, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" x.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn10r",
      "id": "fn10"
    }
  }, [_vm._v("10.")]), _vm._v(" Kidner, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 22.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn11r",
      "id": "fn11"
    }
  }, [_vm._v("11.")]), _vm._v(" Snell, "), _c('i', [_vm._v("Twice-Told Proverbs.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn12r",
      "id": "fn12"
    }
  }, [_vm._v("12.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 57.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn13r",
      "id": "fn13"
    }
  }, [_vm._v("13.")]), _vm._v(" Clifford, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 3.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn14r",
      "id": "fn14"
    }
  }, [_vm._v("14.")]), _vm._v(" Clifford, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 5.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn15r",
      "id": "fn15"
    }
  }, [_vm._v("15.")]), _vm._v(" Kayatz, "), _c('i', [_vm._v("Studien zu Proverbien 1–9.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn16r",
      "id": "fn16"
    }
  }, [_vm._v("16.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 6.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn17r",
      "id": "fn17"
    }
  }, [_vm._v("17.")]), _vm._v(" Waltke, "), _c('i', [_vm._v("Proverbs 1–15,")]), _vm._v(" 37.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn18r",
      "id": "fn18"
    }
  }, [_vm._v("18.")]), _vm._v(" McKane, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 51-182.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn19r",
      "id": "fn19"
    }
  }, [_vm._v("19.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 45.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn20r",
      "id": "fn20"
    }
  }, [_vm._v("20.")]), _vm._v(" Yoder, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 110.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn21r",
      "id": "fn21"
    }
  }, [_vm._v("21.")]), _vm._v(" Hildebrandt, ‘Proverbial Pairs’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn22r",
      "id": "fn22"
    }
  }, [_vm._v("22.")]), _vm._v(" Hildebrandt, ‘Proverbial Strings’, 171-85.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn23r",
      "id": "fn23"
    }
  }, [_vm._v("23.")]), _vm._v(" Van Leeuwen, "), _c('i', [_vm._v("Context and Meaning.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn24r",
      "id": "fn24"
    }
  }, [_vm._v("24.")]), _vm._v(" Heim, "), _c('i', [_vm._v("Like Grapes of Gold Set in Silver,")]), _vm._v(" 7-68.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn25r",
      "id": "fn25"
    }
  }, [_vm._v("25.")]), _vm._v(" Heim, "), _c('i', [_vm._v("Like Grapes of Gold Set in Silver,")]), _vm._v(" 107.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn26r",
      "id": "fn26"
    }
  }, [_vm._v("26.")]), _vm._v(" Waltke, "), _c('i', [_vm._v("Proverbs 1–15,")]), _vm._v(" 21.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn27r",
      "id": "fn27"
    }
  }, [_vm._v("27.")]), _vm._v(" Waltke, "), _c('i', [_vm._v("Proverbs 1–15,")]), _vm._v(" 47.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn28r",
      "id": "fn28"
    }
  }, [_vm._v("28.")]), _vm._v(" Heim, "), _c('i', [_vm._v("Like Grapes of Gold Set in Silver,")]), _vm._v(" 111-46.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn29r",
      "id": "fn29"
    }
  }, [_vm._v("29.")]), _vm._v(" Waltke, "), _c('i', [_vm._v("Proverbs 1–15,")]), _vm._v(" 447-515.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn30r",
      "id": "fn30"
    }
  }, [_vm._v("30.")]), _vm._v(" Fox, ‘Like Grapes of Gold Set in Silver’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn31r",
      "id": "fn31"
    }
  }, [_vm._v("31.")]), _vm._v(" Heim, "), _c('i', [_vm._v("Like Grapes of Gold Set in Silver,")]), _vm._v(" 55-57.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn32r",
      "id": "fn32"
    }
  }, [_vm._v("32.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 10–31,")]), _vm._v(" 480.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn33r",
      "id": "fn33"
    }
  }, [_vm._v("33.")]), _vm._v(" McKane, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn34r",
      "id": "fn34"
    }
  }, [_vm._v("34.")]), _vm._v(" Schwáb, ‘Sayings Clusters in Proverbs’, 60.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn35r",
      "id": "fn35"
    }
  }, [_vm._v("35.")]), _vm._v(" Longman, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 40-41.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn36r",
      "id": "fn36"
    }
  }, [_vm._v("36.")]), _vm._v(" Berlin, "), _c('i', [_vm._v("Dynamics of Biblical Parallelism,")]), _vm._v(" argues that parallelism and terseness are "), _c('i', [_vm._v("the")]), _vm._v(" marks of Hebrew poetry. Others give longer lists, for example: Gillingham, "), _c('i', [_vm._v("Poems and Psalms of the Hebrew Bible;")]), _vm._v(" Watson, "), _c('i', [_vm._v("Classical Hebrew Poetry.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn37r",
      "id": "fn37"
    }
  }, [_vm._v("37.")]), _vm._v(" O’Connor, "), _c('i', [_vm._v("Hebrew Verse Structure,")]), _vm._v(" 122-29 and 401-404.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn38r",
      "id": "fn38"
    }
  }, [_vm._v("38.")]), _vm._v(" Fox, ‘Rhetoric of Disjointed Proverbs’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn39r",
      "id": "fn39"
    }
  }, [_vm._v("39.")]), _vm._v(" Murphy, "), _c('i', [_vm._v("Wisdom Literature,")]), _vm._v(" 11-12.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn40r",
      "id": "fn40"
    }
  }, [_vm._v("40.")]), _vm._v(" Roth, ‘Numerical Sequence x/x+1 in the Old Testament’. The examples are given on 304-305.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn41r",
      "id": "fn41"
    }
  }, [_vm._v("41.")]), _vm._v(" Lindenberger, ‘Ahiqar’, 499.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn42r",
      "id": "fn42"
    }
  }, [_vm._v("42.")]), _vm._v(" Lindenberger, ‘Ahiqar’, 481.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn43r",
      "id": "fn43"
    }
  }, [_vm._v("43.")]), _vm._v(" Lindenberger, ‘Ahiqar’, 482.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn44r",
      "id": "fn44"
    }
  }, [_vm._v("44.")]), _vm._v(" Wyatt, "), _c('i', [_vm._v("Religious Texts from Ugarit,")]), _vm._v(" 96.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn45r",
      "id": "fn45"
    }
  }, [_vm._v("45.")]), _vm._v(" Roth, ‘Numerical Sequence x/x+1 in the Old Testament’. The examples are given on 305-306.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn46r",
      "id": "fn46"
    }
  }, [_vm._v("46.")]), _vm._v(" Nel, ‘Genres of Biblical Wisdom Literature’, esp. 135, n. 30.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn47r",
      "id": "fn47"
    }
  }, [_vm._v("47.")]), _vm._v(" Roth, "), _c('i', [_vm._v("Numerical Sayings in the Old Testament.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn48r",
      "id": "fn48"
    }
  }, [_vm._v("48.")]), _vm._v(" "), _c('i', [_vm._v("AEL")]), _vm._v(" 1:58-59.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn49r",
      "id": "fn49"
    }
  }, [_vm._v("49.")]), _vm._v(" "), _c('i', [_vm._v("AEL")]), _vm._v(" 1:61-80.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn50r",
      "id": "fn50"
    }
  }, [_vm._v("50.")]), _vm._v(" "), _c('i', [_vm._v("COS")]), _vm._v(" 1:61-66; "), _c('i', [_vm._v("AEL")]), _vm._v(" 1:97-109.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn51r",
      "id": "fn51"
    }
  }, [_vm._v("51.")]), _vm._v(" "), _c('i', [_vm._v("COS")]), _vm._v(" 1:66-68; "), _c('i', [_vm._v("AEL")]), _vm._v(" 1:135-39.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn52r",
      "id": "fn52"
    }
  }, [_vm._v("52.")]), _vm._v(" "), _c('i', [_vm._v("COS")]), _vm._v(" 1:110-115; "), _c('i', [_vm._v("AEL")]), _vm._v(" 2:135-46.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn53r",
      "id": "fn53"
    }
  }, [_vm._v("53.")]), _vm._v(" "), _c('i', [_vm._v("COS")]), _vm._v(" 1:115-122; "), _c('i', [_vm._v("AEL")]), _vm._v(" 2:146-63.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn54r",
      "id": "fn54"
    }
  }, [_vm._v("54.")]), _vm._v(" Ray, ‘Egyptian Wisdom Literature’, 23.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn55r",
      "id": "fn55"
    }
  }, [_vm._v("55.")]), _vm._v(" "), _c('i', [_vm._v("AEL")]), _vm._v(" 3:159-84.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn56r",
      "id": "fn56"
    }
  }, [_vm._v("56.")]), _vm._v(" "), _c('i', [_vm._v("COS")]), _vm._v(" 1:569-70.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn57r",
      "id": "fn57"
    }
  }, [_vm._v("57.")]), _vm._v(" Alster, "), _c('i', [_vm._v("Proverbs of Ancient Sumer. COS")]), _vm._v(" 1:563-567.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn58r",
      "id": "fn58"
    }
  }, [_vm._v("58.")]), _vm._v(" Lambert, "), _c('i', [_vm._v("BWL,")]), _vm._v(" 96-107. A more recent translation can be found in: Foster, "), _c('i', [_vm._v("Before the Muses,")]), _vm._v(" 412-15.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn59r",
      "id": "fn59"
    }
  }, [_vm._v("59.")]), _vm._v(" Lindenberger, "), _c('i', [_vm._v("Aramaic Proverbs of Ahiqar;")]), _vm._v(" ‘Ahiqar’ 479-507.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn60r",
      "id": "fn60"
    }
  }, [_vm._v("60.")]), _vm._v(" "), _c('i', [_vm._v("Ahiqar")]), _vm._v(" lines 81-82, "), _c('i', [_vm._v("OTP")]), _vm._v(" 2:498.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn61r",
      "id": "fn61"
    }
  }, [_vm._v("61.")]), _vm._v(" Clifford, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 17-19.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn62r",
      "id": "fn62"
    }
  }, [_vm._v("62.")]), _vm._v(" Budge, "), _c('i', [_vm._v("Facsimiles of Egyptian Hieratic Papyri,")]), _vm._v(" plates I-XIV. The text is British Museum Papyrus 10474.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn63r",
      "id": "fn63"
    }
  }, [_vm._v("63.")]), _vm._v(" For a modern English translation see: "), _c('i', [_vm._v("COS")]), _vm._v(" 1:115-22.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn64r",
      "id": "fn64"
    }
  }, [_vm._v("64.")]), _vm._v(" Whybray, "), _c('i', [_vm._v("Book of Proverbs,")]), _vm._v(" 8.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn65r",
      "id": "fn65"
    }
  }, [_vm._v("65.")]), _vm._v(" Ray, ‘Egyptian Wisdom Literature’, 17-29.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn66r",
      "id": "fn66"
    }
  }, [_vm._v("66.")]), _vm._v(" Williams, ‘Alleged Semitic Original’, 100-106.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn67r",
      "id": "fn67"
    }
  }, [_vm._v("67.")]), _vm._v(" Whybray, "), _c('i', [_vm._v("Book of Proverbs,")]), _vm._v(" 132-47; Whybray, ‘Structure and Composition of Proverbs 22:17–24:22’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn68r",
      "id": "fn68"
    }
  }, [_vm._v("68.")]), _vm._v(" Niccacci, ‘Proverbi 22.17–23.11’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn69r",
      "id": "fn69"
    }
  }, [_vm._v("69.")]), _vm._v(" Emerton, ‘Amenemope and Proverbs XXII 17–XXIV 22’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn70r",
      "id": "fn70"
    }
  }, [_vm._v("70.")]), _vm._v(" This is true for Hebrew. In a personal communication (8/8/05) K. A. Kitchen pointed out examples where it does stand on its own in Akkadian. See the examples in "), _c('i', [_vm._v("CAD")]), _vm._v(" 17:262b, 268b-69a.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn71r",
      "id": "fn71"
    }
  }, [_vm._v("71.")]), _vm._v(" GKC §134; Joüon Part 3, §142 n.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn72r",
      "id": "fn72"
    }
  }, [_vm._v("72.")]), _vm._v(" Ruffle, ‘Teaching of Amenemope’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn73r",
      "id": "fn73"
    }
  }, [_vm._v("73.")]), _vm._v(" Gressmann, ‘Neugefundene Lehre des Amen-em-ope’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn74r",
      "id": "fn74"
    }
  }, [_vm._v("74.")]), _vm._v(" Fox, ‘’From Amenemope to Proverbs’, 91.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn75r",
      "id": "fn75"
    }
  }, [_vm._v("75.")]), _vm._v(" Waltke, "), _c('i', [_vm._v("Proverbs 1–15,")]), _vm._v(" 22-24.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn76r",
      "id": "fn76"
    }
  }, [_vm._v("76.")]), _vm._v(" Malchow, ‘Manual’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn77r",
      "id": "fn77"
    }
  }, [_vm._v("77.")]), _vm._v(" Eissfeldt, "), _c('i', [_vm._v("Maschal im Alten Testament.")]), _vm._v(" See also his "), _c('i', [_vm._v("Old Testament: An Introduction,")]), _vm._v(" 12, 81-87.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn78r",
      "id": "fn78"
    }
  }, [_vm._v("78.")]), _vm._v(" Scott, ‘Folk Proverbs of the Ancient Near East’, reprinted in Crenshaw, "), _c('i', [_vm._v("Studies in Ancient Israelite Wisdom,")]), _vm._v(" 417-26; Scott, ‘Study of the Wisdom Literature’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn79r",
      "id": "fn79"
    }
  }, [_vm._v("79.")]), _vm._v(" Westermann, ‘Weisheit in Sprichwort’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn80r",
      "id": "fn80"
    }
  }, [_vm._v("80.")]), _vm._v(" Collected in Golka, "), _c('i', [_vm._v("Leopard’s Spots.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn81r",
      "id": "fn81"
    }
  }, [_vm._v("81.")]), _vm._v(" Naré, "), _c('i', [_vm._v("Proverbes salomoniens et proverbes mossi.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn82r",
      "id": "fn82"
    }
  }, [_vm._v("82.")]), _vm._v(" Whybray, "), _c('i', [_vm._v("Wealth and Poverty in the Book of Proverbs.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn83r",
      "id": "fn83"
    }
  }, [_vm._v("83.")]), _vm._v(" Fox, ‘Social Location’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn84r",
      "id": "fn84"
    }
  }, [_vm._v("84.")]), _vm._v(" Loader, ‘Wisdom by (the) People for (the) People’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn85r",
      "id": "fn85"
    }
  }, [_vm._v("85.")]), _vm._v(" Golka, ‘Wisdom by (the) People for (the) People: Einne Antwort’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn86r",
      "id": "fn86"
    }
  }, [_vm._v("86.")]), _vm._v(" Kimilike, "), _c('i', [_vm._v("Poverty in the Book of Proverbs.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn87r",
      "id": "fn87"
    }
  }, [_vm._v("87.")]), _vm._v(" Kassis, "), _c('i', [_vm._v("Book of Proverbs and Arabic Proverbial Works.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn88r",
      "id": "fn88"
    }
  }, [_vm._v("88.")]), _vm._v(" Van Leeuwen, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 21-22.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn89r",
      "id": "fn89"
    }
  }, [_vm._v("89.")]), _vm._v(" Williams, ‘Power of Form’. The quote is on 49.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn90r",
      "id": "fn90"
    }
  }, [_vm._v("90.")]), _vm._v(" Kassis, "), _c('i', [_vm._v("Book of Proverbs and Arabic Proverbial Works,")]), _vm._v(" 249-64.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn91r",
      "id": "fn91"
    }
  }, [_vm._v("91.")]), _vm._v(" Murphy, "), _c('i', [_vm._v("Wisdom Literature,")]), _vm._v(" 4.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn92r",
      "id": "fn92"
    }
  }, [_vm._v("92.")]), _vm._v(" See the brief survey in Lucas, "), _c('i', [_vm._v("Psalms and Wisdom Literature,")]), _vm._v(" 82-85.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn93r",
      "id": "fn93"
    }
  }, [_vm._v("93.")]), _vm._v(" Fox, ‘Social Location’, 231.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn94r",
      "id": "fn94"
    }
  }, [_vm._v("94.")]), _vm._v(" Humphreys, ‘Motif of the Wise Courtier’, 187.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn95r",
      "id": "fn95"
    }
  }, [_vm._v("95.")]), _vm._v(" Sandoval, "), _c('i', [_vm._v("Wealth and Poverty,")]), _vm._v(" 39.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn96r",
      "id": "fn96"
    }
  }, [_vm._v("96.")]), _vm._v(" Fox, ‘Social Location’, 236, his italics.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn97r",
      "id": "fn97"
    }
  }, [_vm._v("97.")]), _vm._v(" Whybray, "), _c('i', [_vm._v("Book of Proverbs,")]), _vm._v(" 20.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn98r",
      "id": "fn98"
    }
  }, [_vm._v("98.")]), _vm._v(" Washington, "), _c('i', [_vm._v("Wealth and Poverty,")]), _vm._v(" 50.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn99r",
      "id": "fn99"
    }
  }, [_vm._v("99.")]), _vm._v(" Fox, ‘Social Location’, 237.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn100r",
      "id": "fn100"
    }
  }, [_vm._v("100.")]), _vm._v(" Harrington, "), _c('i', [_vm._v("Wisdom Texts from Qumran.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn101r",
      "id": "fn101"
    }
  }, [_vm._v("101.")]), _vm._v(" Cook, ‘Dating of Septuagint Proverbs’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn102r",
      "id": "fn102"
    }
  }, [_vm._v("102.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 363.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn103r",
      "id": "fn103"
    }
  }, [_vm._v("103.")]), _vm._v(" Clifford, ‘Observations on the Texts and Versions of Proverbs’, 61.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn104r",
      "id": "fn104"
    }
  }, [_vm._v("104.")]), _vm._v(" Fritsch, ‘Treatment of the Hexaplaric Signs in the Syro-Hexaplar of Proverbs’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn105r",
      "id": "fn105"
    }
  }, [_vm._v("105.")]), _vm._v(" Snell, "), _c('i', [_vm._v("Twice-Told Proverbs,")]), _vm._v(" 23-33.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn106r",
      "id": "fn106"
    }
  }, [_vm._v("106.")]), _vm._v(" Gerleman, "), _c('i', [_vm._v("Studies in the Septuagint III,")]), _vm._v(" 12.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn107r",
      "id": "fn107"
    }
  }, [_vm._v("107.")]), _vm._v(" Cook, "), _c('i', [_vm._v("Septuagint of Proverbs,")]), _vm._v(" 12, 35.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn108r",
      "id": "fn108"
    }
  }, [_vm._v("108.")]), _vm._v(" Clifford, ‘Observations on the Texts and Versions of Proverbs’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn109r",
      "id": "fn109"
    }
  }, [_vm._v("109.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 361.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn110r",
      "id": "fn110"
    }
  }, [_vm._v("110.")]), _vm._v(" Cook, "), _c('i', [_vm._v("Septuagint of Proverbs,")]), _vm._v(" 334.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn111r",
      "id": "fn111"
    }
  }, [_vm._v("111.")]), _vm._v(" McKane, "), _c('i', [_vm._v("Proverbs,")]), _vm._v(" 33-47.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn112r",
      "id": "fn112"
    }
  }, [_vm._v("112.")]), _vm._v(" Cook, "), _c('i', [_vm._v("Septuagint of Proverbs,")]), _vm._v(" 334.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn113r",
      "id": "fn113"
    }
  }, [_vm._v("113.")]), _vm._v(" Tov, ‘Recensional Differences’.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn114r",
      "id": "fn114"
    }
  }, [_vm._v("114.")]), _vm._v(" Fox, "), _c('i', [_vm._v("Proverbs 1–9,")]), _vm._v(" 364.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/#fn115r",
      "id": "fn115"
    }
  }, [_vm._v("115.")]), _vm._v(" Clifford, ‘Observations on the Texts and Versions of Proverbs’, 60.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e0dad0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-lucas-0009.vue
// module id = 78
// module chunks = 0